




































































































































































































































































































































































































































































































































































































































































































































































































































































































































import AddressAutocomplete from "@/components/shipments/EditShipment/AddressAutocomplete.vue";
import axios from "axios";
import * as equal from "fast-deep-equal";
import Vue from "vue";
import { Debounce } from "vue-debounce-decorator";
import { Component, Emit, Prop, Provide, Watch } from "vue-property-decorator";
import {
  CourierBusiness,
  SelectOptionDef,
  TranslatedCountryDTO
} from "@/model/component.model";
import {
  AddressDTO,
  AddressLocatorDto,
  AddressShipmentDTO,
  ConfigurationDTO,
  ContactDTO,
  CountryDTO,
  CourierDTO,
  CourierPackageTypeDTO,
  CourierServiceCodesConfigurationDto,
  CourierServiceDTO,
  DepartmentDTO,
  MbeServiceDTO,
  OnlineMbeCourierVisibilityDto,
  PackageDTO,
  PaymentTypesDTO,
  ProformaDetailsDTO,
  ShipmentDetailsInputDTO,
  ShipmentDetailsOutputDTO,
  ShipmentDTO,
  ShipmentExtraServiceDTO,
  ShipmentPackageDTO,
  ShipType,
  SubcountryDTO,
  WineCourierServiceDTO,
  ZonosCalculateResponseDTO,
  ZonosCalculateResponseItemDTO,
  ZonosProformaDetailsDTO,
  ZonosProformaDTO
} from "@/model/data.model";
import { AlertBus } from "@/plugins/alerts/AlertBus";
import {
  getCurrencies,
  getMultiStoreId,
  getTenantId
} from "@/services/AuthService";
import { ContactService } from "@/services/ContactService";
import {
  canGenerateDualUse,
  dualUseDocumentType,
  dualUseFilename,
  replaceDualUse
} from "@/model/dualUse.model";
import {
  alertDangerReason,
  convertBase64toBlob,
  fieldSorter,
  getCustomerCommercialName,
  getLanguageFromTenant,
  getStoreCompanyName,
  isFrance,
  isGermany,
  isSpain,
  isItaly,
  isPortugal
} from "@/services/Helpers";
import { PriceListService } from "@/services/PriceListService";
import ProformaService from "@/services/ProformaService";
import { ShipmentService } from "@/services/ShipmentService";
import { TaxDutyService } from "@/services/TaxDutyService";
import Accordion from "@/components/shared/Accordion.vue";
import Modal from "../../shared/modal/Modal.vue";
import FullScreenModal from "@/components/shared/modal/FullScreenModal.vue";
import Address from "./Address.vue";
import Calculator from "./Calculator.vue";
import ConfirmShipment from "./ConfirmShipment.vue";
import ExtraServices, {
  COD,
  INSURANCE_COURIER,
  MBE_SAFE_VALUE
} from "./ExtraServices.vue";
import MBEService from "./MBEService.vue";
import Notes from "./Notes.vue";
import PackageDefinition from "./PackageDefinition.vue";
import PickupContent from "./PickupContent.vue";
import SearchContactModal from "./SearchContactModal.vue";
import Sidebar from "./Sidebar.vue";
import Toolbar from "./Toolbar.vue";
import Topbar from "./Topbar.vue";
import store from "@/vuex/store";
import i18n from "@/lang/i18n";
import { requiredIf, required, minValue } from "vuelidate/lib/validators";
import { Validations } from "vuelidate-property-decorators";
import { getStoreId } from "@/services/AuthService";
import { CustomerService } from "@/services/CustomerService";
import ShipmentAccessPoints from "../ShipmentAccessPoints.vue";
import { EventBus } from "@/event-bus";
import cloneDeep from "lodash/cloneDeep";
import AttachmentsModal from "@/components/shipments/ShipmentsManagement/AttachmentsModal.vue";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import PaperlessManagementTable from "@/components/shipments/PaperlessManagementTable.vue";
import AddPaperlessDocumentModalComponent from "@/components/shipments/AddPaperlessDocumentModal.vue";
import provinceValidator from "@/definitions/province-validator";
import { emailValidator } from "@/definitions/email-validator";
import isPhone from "@/definitions/telephone-validator";
import { MBEShipServiceBusiness } from "@/model/enumeration.model";
import { fedexAsksShipmentValue } from "@/model/shipmentValue.model";
import { hasPaperlessDocuments } from "@/model/paperlessPostClosure.model";
import { getKeyValueConfig } from "@/utils/fetchKeyValueConfigLevel";

@Component({
  components: {
    PaperlessManagementTable,
    AddressAutocomplete: AddressAutocomplete,
    MbeAccordion: Accordion,
    Topbar: Topbar,
    Sender: Address,
    Receiver: Address,
    MbeService: MBEService,
    MbeModal: Modal,
    Calculator,
    Notes: Notes,
    ExtraServices: ExtraServices,
    Sidebar: Sidebar,
    Toolbar: Toolbar,
    ConfirmShipment: ConfirmShipment,
    MbeFullScreenModal: FullScreenModal,
    SearchContactModal: SearchContactModal,
    PickupContent: PickupContent,
    ShipmentAccessPoints,
    DecimalNumber,
    MbeAttachmentsModal: AttachmentsModal,
    AddPaperlessDocumentModal: AddPaperlessDocumentModalComponent
  }
})
export default class ShipmentForm extends Vue {
  @Provide()
  contactService = new ContactService(
    this.$store.getters["customer/customerMbeId"]
  );

  @Prop({ type: Boolean, default: false }) hasInvalidPackageDimension: boolean;
  @Prop({ default: "0" }) fromShipManagm: string;
  @Prop({ default: false }) isWineShipment: boolean;
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean; // shipment is editable
  @Prop() newCreatedShipment: boolean;
  @Prop() editedShipment: boolean;
  @Prop() senderAddressOperation: string;
  @Prop() receiverAddressOperation: string;

  searchContactModalVisible = false;
  searchContactModalSource = "";
  modalSearchContactOptions = {
    addressData: {},
    classicon: "invoice-image",
    title: i18n.t("search")
  };
  countries: TranslatedCountryDTO[] = [];
  allSubCountries: SubcountryDTO[] = [];
  currencies: any[] = [];
  totalImportCurrency: any = { code: "EUR", id: 0 };
  changedCourierModal = false;
  zonosTotalCost: number | string = "";
  courier1 = "";
  courier2 = "";
  removeEssential = true;
  isProformaDone = false;
  showAccessPointsModal = false;
  errorMbeServiceAndCalculator = [];
  isDeliveryPointSelected = false;
  errorMaxPackageWeight = false;
  errorNoPackageWeight = false;
  errorMaxShipmentWeight = false;
  errorNoShipmentWeight = false;
  errorMultipackage = false;
  errorPackageSizeMandatory = false;
  errorMaxSafeValue = false;
  errorMaxCod = false;
  errorMaxInsurance = false;
  receiverTypeAddress = "fromUser";
  oldPriceSource = undefined;
  isPhoneRequired = isSpain();
  isEmailRequired = isSpain();
  isEmailRequiredNew = !isGermany();
  disabledMbePricelist = false;
  detailsInError = false;
  sv4bMin: number = null;
  sv4bMax: number = null;
  sv4bValue: number = null;
  sv4bCoverage: boolean = null;
  openProforma = false;
  zonosCalculateCalled = false;
  disableDDPOptions = false;
  disableZonosDDP = false;
  newShipmentEventBus = new Vue();
  selectedToCountry: SelectOptionDef = {
    label: " ",
    value: "",
    labelTranslated: ""
  } as SelectOptionDef;
  departmentSelected: any = "";
  showAddPaperlessModal = false;
  detailsCalled = false;
  pickupOptionVisible = false;
  serviceId: any[] = [];
  mbeserviceSelected = null as MbeServiceDTO;
  courierChosenByAutopilot = 0;
  enabledAutopilotCouriers: number[] = [];
  courierPickupEmpty = false;
  autopilotAvailableMbeServices: number[] = [];
  oldMbeServiceId: any = undefined;
  oldMbeService: any = undefined;
  isDraft = 2;
  modalAttachmentsVisible = false;
  disableAttachmentPaperlessDocumentFlag = false;
  notVisibleCourierService: any = null;
  showPastPaperlessDocuments = false;
  // Closed shipment without courier AWB: customer can only attach/detach paperless documents
  paperlessPostClosure = false;
  shipmentLockedForPaperless = false;
  oldShipmentData: ShipmentDTO | null = null;
  zonosCourierServicesList: number[] = [];
  zonosGuaranteeDisabledCourierServicesList: number[] = [];
  taxAndDutyExternalCall = false;
  initShipmentDetails = false;
  initDone = false;
  initResetZonos = false;
  initZonosCourierServiceList = false;
  calculateTaxDutyBtnTriggered = false;
  dimensionWineProductType: null | string = null;
  watchSenderAddress = false;
  courierPackageTypes: CourierPackageTypeDTO[] = [];
  prices: ShipmentDetailsOutputDTO | null = null;
  vatPercentage = 0;
  vatId = 0;
  vatCode = "";
  vatName = "";
  currency = "EUR";
  timeOverlap = 0 as number;
  shipAndPackIncluded: boolean = null;
  availablePickup: CourierDTO[] = [];
  mbeServiceIdChecked: boolean;
  packTypes: any = [];
  isToUSAPopup = false;
  canSaveShipment = true;
  updateAutopilot = false;
  isPackageDimensionChange = false;
  zonosReseted = false;
  hideDDPValues = false;
  isTaxDutyStoreEnabled = false;
  isTaxDutyZonosStoreEnabled = false;
  wineDefaultWarehouses = [];
  warehouseSelected = null;
  disableGoodsValueLock = false;
  wineCourierService: null | WineCourierServiceDTO = null;

  changeProvince() {
    return undefined;
  }

  @Watch("openProforma")
  onProformaOpen(status: boolean) {
    if (status) {
      this.oldShipmentData = this.shipment ? cloneDeep(this.shipment) : null;
    }
  }

  get dimensionWineProductTypes() {
    let productTypes: SelectOptionDef[] = [
      { value: "wine_us", label: "DIMENSION_PRODUCT_TYPE_WINE_US" },
      { value: "spirits_us", label: "DIMENSION_PRODUCT_TYPE_SPIRITS_US" },
      { value: "spirits_all", label: "DIMENSION_PRODUCT_TYPE_SPIRITS_ALL" },
      { value: "wine_all", label: "DIMENSION_PRODUCT_TYPE_WINE_ALL" }
    ];

    if (isItaly() || isSpain() || isPortugal()) {
      productTypes = productTypes.filter(el => !(el.value === "spirits_us"));
    }

    if (!this.$store.getters["customer/config"].enableWineShipmentCreation) {
      productTypes = productTypes.filter(
        el => !(el.value === "wine_us") && !(el.value === "wine_all")
      );
    }

    if (!this.$store.getters["customer/config"].enableSpiritsShipmentCreation) {
      productTypes = productTypes.filter(
        el => !(el.value === "spirits_us") && !(el.value === "spirits_all")
      );
    }

    return productTypes;
  }

  get isDimensionWineProductTypeValid() {
    if (!this.isWineShipment) return true;
    return this.dimensionWineProductType;
  }

  get defaultPhoneRequired() {
    return isSpain();
  }

  get showProformaTotalValueSection() {
    return (
      this.shipment.proforma || this.isWineShipment || !this.disableProformaEdit
    );
  }

  get isZonosCourierServiceSupported() {
    return Boolean(
      this.zonosCourierServicesList.length > 0 &&
        this.courierServiceId &&
        this.zonosCourierServicesList.includes(Number(this.courierServiceId))
    );
  }

  get isValidChargeCustomDutiesDefinedByMolUser() {
    if (!this.showCanChargeCustomDutiesDefinedByMolUser) return true;
    if (!this.shipment.requestedChargeCustomDutiesDefinedByMolUser) return true;
    if (this.isCourierFedex || this.isCourierDHL) {
      return (
        this.$v.shipment.codeAccountForCustomDuties &&
        !this.$v.shipment.codeAccountForCustomDuties.$invalid
      );
    }
    if (this.isCourierUPS) {
      return (
        this.$v.shipment.codeAccountForCustomDuties &&
        this.$v.shipment.zipCodeForCustomDuties &&
        this.$v.shipment.countryCodeForCustomDuties &&
        !this.$v.shipment.codeAccountForCustomDuties.$invalid &&
        !this.$v.shipment.zipCodeForCustomDuties.$invalid &&
        !this.$v.shipment.countryCodeForCustomDuties.$invalid
      );
    }
    return false;
  }

  get enableZonosCalculateBtn() {
    return Boolean(
      this.zonosProforma &&
        this.zonosProforma.items &&
        this.zonosProforma.languageCode &&
        Object.keys(this.zonosProforma.items).length > 0 &&
        this.showTaxDutyLogic &&
        this.isZonosCourierServiceSupported &&
        this.edition
    );
  }

  @Watch("isZonosCourierServiceSupported")
  onZonosCourierServiceSupportedChange(supported: boolean) {
    if (
      supported ||
      !this.showTaxDutyLogic ||
      !this.shipment ||
      !this.shipment.proforma ||
      this.shipment.proforma.incoterms !== "DDP"
    ) {
      return;
    }

    this.hideDDPValues = false;
    this.disableDDPOptions = false;
  }

  get defaultReceiverEmailRequired() {
    return isSpain();
  }

  get isProformaDDP() {
    if (!this.shipment || !this.shipment.proforma) return false;
    return this.shipment.proforma.incoterms === "DDP";
  }

  get isProformaIncotermDAP() {
    if (!this.shipment || !this.shipment.proforma) return false;
    return this.shipment.proforma.incoterms === "DAP";
  }

  updateCeeAddressFor(cee) {
    this.shipment.addressFor.cee = cee;
  }

  searchDocuments(idToSelect?: number) {
    (this.$refs.paperless_table as PaperlessManagementTable).search(idToSelect);
  }

  get getReceiverEdition() {
    if (!this.edition) return this.edition;
    return (
      this.isInboundShipment ||
      !this.hasAccessPointData ||
      this.isThirdPartShipment
    );
  }

  get getSenderEdition() {
    if (
      this.isInboundShipment &&
      this.$route.params.id !== undefined &&
      (this.shipment.status === "DRAFT_NO_WAYBILL" ||
        this.shipment.status === "DRAFT_WAYBILL" ||
        this.shipment.status === "CREATED" ||
        this.shipment.delivered === true)
    ) {
      return false;
    } else {
      return (
        this.shipment.shipmentType === "IMPORT" ||
        this.isInboundShipment ||
        this.isThirdPartShipment ||
        this.isWineShipment
      );
    }
  }

  get enableOpenModalButton() {
    return this.isDeliveryPointSelected;
  }

  get useCustomerAddressAsSender() {
    return this.$store.getters["customer/config"].customerAddressAsSender;
  }

  get configurationInvalid() {
    //check / prevent invalid configurations
    //cannot create new with department mandatory and no department
    if (
      this.$store.getters["customer/config"].isDepartmentMandatory &&
      this.edition &&
      this.$store.getters["customer/departments"].length === 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  get zonosCalculateResponse() {
    return this.$store.getters[
      "shipment/zonosCalculateResponse"
    ] as null | ZonosCalculateResponseDTO;
  }

  get countryValues() {
    return this.countries.map((countryDto: CountryDTO) => {
      return {
        label: String(countryDto.name),
        labelTranslated: String(i18n.t("country_" + countryDto.id)),
        value: countryDto.id
      } as SelectOptionDef;
    });
  }

  get isProformaButtonDisabled() {
    return !this.edition;
  }

  get showTaxDutyCalculationBtnMandatoryError(): boolean {
    if (!this.showTaxDutyLogic) return false;
    return Boolean(
      this.zonosTotalCost === "" &&
        this.shipment.ddpZonos &&
        this.isZonosCourierServiceSupported
    );
  }

  get showTaxDutyProformaBtnError() {
    if (!this.showTaxDutyLogic) return false;
    //shipment.proforma || isWineShipment || !disableProformaEdit
    return (
      (!this.shipment.proforma ||
        !this.shipment.proforma.proformaDetails.length) &&
      this.calculateTaxDutyBtnTriggered
    );
  }

  set proformaCurrency(value: any) {
    this.shipment.currency = value.code;
    this.shipment.proforma.currency = value.code;

    if (this.shipment.extraServices !== undefined) {
      this.shipment.extraServices.forEach(item => {
        if (item.extraServiceName === "Cash on Delivery") {
          item.currency = value.code;
          item.currencyId = value.id;
        }
      });
    }

    this.currency = value.code;
    this.totalImportCurrency = value;
  }

  get proformaCurrency(): any {
    return this.totalImportCurrency;
  }

  set proformaTotalValue(value: any) {
    this.shipment.proforma.totalValue = value;
  }

  get proformaTotalValue(): any {
    return this.shipment.proforma.totalValue;
  }

  get showCanChargeCustomDutiesDefinedByMolUser() {
    if (!this.canSelectCourier) return false;
    if (!this.isCourierUPS && !this.isCourierDHL && !this.isCourierFedex)
      return false;
    return this.$store.getters["customer/config"]
      .canChargeCustomDutiesDefinedByMolUser;
  }

  get showProformaButton() {
    const hideProforma = this.$store.getters["customer/config"]
      .hideStoreProforma;
    if (hideProforma && this.shipment.proforma.createdByStore) return false;
    return true;
  }

  get hidePaperless() {
    return this.$store.getters["customer/config"].disablePaperlessFeature;
  }

  timeOverlapFunction(value: number) {
    this.timeOverlap = value;
  }

  @Validations()
  validations() {
    if (this.totalProformaRequired) {
      return {
        shipment: {
          proforma: {
            totalValue: {
              required: requiredIf(function(this: ShipmentForm) {
                if (!isFrance()) return true;
                // #555656884 For export shipments, on MBE Online, for envelopes and documents (less than 2kg), the "Total amount" field should not be mandatory.
                if (this.$refs.calculator != undefined) {
                  const weightConditionNotMandatory: boolean =
                    (this.$refs.calculator as Calculator)
                      .totalWeightIncludingVolumetricWeight < 2;
                  if (
                    (this.shipment.shipPackType === "Envelope" ||
                      this.shipment.shipPackType === "Documents") &&
                    weightConditionNotMandatory
                  )
                    return false;
                }
                return true;
              })
            }
          },
          addressFrom: {
            address: { required },
            companyName: { required },
            zipCode: { required },
            city: { required },
            countryName: { required },
            subcountry: { required },
            email: {
              emailValidator,
              required: requiredIf(
                () =>
                  this.isEmailRequired ||
                  (this.$route.query.type === "inbound" &&
                    this.isEmailRequiredNew)
              )
            },
            secondEmail: { emailValidator },
            contact: {
              required: requiredIf(function(this: Address) {
                return this.$store.getters["customer/info"].tenantId !== 3;
              })
            },
            phone: {
              isPhone,
              required: requiredIf(() => this.$route.query.type === "inbound")
            },
            secondPhone: { isPhone },
            province: {
              validator: provinceValidator(
                this.$props.shipment.addressFrom.countryName,
                undefined
              )
            }
          },
          addressTo: {
            address: { required },
            companyName: { required },
            zipCode: { required },
            city: { required },
            countryName: { required },
            subcountry: { required },
            email: {
              emailValidator,
              required: requiredIf(
                () =>
                  this.isEmailRequired ||
                  (this.$route.query.type === "inbound" &&
                    this.isEmailRequiredNew) ||
                  this.isGel
              )
            },
            secondEmail: { emailValidator },
            contact: {
              required: requiredIf(function(this: Address) {
                return this.$store.getters["customer/info"].tenantId !== 3;
              })
            },
            phone: {
              isPhone,
              required: requiredIf(
                () =>
                  this.$route.query.type === "inbound" ||
                  this.isPhoneRequired ||
                  this.isGel
              )
            },
            secondPhone: { isPhone },
            province: {
              validator: provinceValidator(
                this.$props.shipment.addressTo.countryName,
                this.hasAccessPoint
              )
            }
          },
          mbeService: {
            required
          },
          courierWeight: {
            minValue: minValue(0.1)
          },
          pickup: {
            preferredFrom: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            },
            preferredTo: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            },
            alternativeFrom: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            },
            alternativeTo: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            },
            note: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            },
            pickupDate: {
              required: requiredIf(function(this: ShipmentForm) {
                return this.getPickupRequest;
              })
            }
          },
          codeAccountForCustomDuties: {
            required
          },
          zipCodeForCustomDuties: {
            required
          },
          countryCodeForCustomDuties: {
            required
          }
        }
      };
    }
    return {
      shipment: {
        addressFrom: {
          address: { required },
          companyName: { required },
          zipCode: { required },
          city: { required },
          countryName: { required },
          subcountry: { required },
          email: {
            emailValidator,
            required: requiredIf(
              () =>
                this.isEmailRequired ||
                (this.$route.query.type === "inbound" &&
                  this.isEmailRequiredNew)
            )
          },
          secondEmail: { emailValidator },
          secondPhone: { isPhone },
          province: {
            validator: provinceValidator(
              this.$props.shipment.addressFrom.countryName,
              undefined
            )
          }
        },
        addressTo: {
          address: { required },
          companyName: { required },
          zipCode: { required },
          city: { required },
          countryName: { required },
          subcountry: { required },
          email: {
            emailValidator,
            required: requiredIf(
              () =>
                this.isEmailRequired ||
                (this.$route.query.type === "inbound" &&
                  this.isEmailRequiredNew) ||
                this.isGel
            )
          },
          secondEmail: { emailValidator },
          contact: {
            required: requiredIf(() => this.shipment.shipmentType === "EXPORT")
          },
          phone: {
            validatePhone: (value: any) => {
              return isPhone(value, this.isUSTariffShipment);
            },
            required: requiredIf(
              () =>
                this.$route.query.type === "inbound" ||
                this.isPhoneRequired ||
                this.isGel
            )
          },
          secondPhone: { isPhone },
          province: {
            validator: provinceValidator(
              this.$props.shipment.addressTo.countryName,
              this.hasAccessPoint
            )
          }
        },
        mbeService: {
          required
        },
        courierWeight: {
          minValue: minValue(0.1)
        },
        pickup: {
          preferredFrom: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          },
          preferredTo: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          },
          alternativeFrom: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          },
          alternativeTo: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          },
          note: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          },
          pickupDate: {
            required: requiredIf(function(this: ShipmentForm) {
              return this.getPickupRequest;
            })
          }
        }
      }
    };
  }

  get hasAccessPoint() {
    return this.shipment.addressAccessPoint !== undefined;
  }

  @Watch("shipment.addressTo.countryId")
  onCountryChange(countryId: string) {
    this.selectedToCountry = {
      value: countryId,
      label: this.shipment.addressTo.countryName,
      labelTranslated: String(i18n.t("country_" + countryId))
    };
  }

  @Watch("dimensionWineProductType")
  onDimensionWineProductTypeChange(newValue: string, oldValue: string) {
    if (!this.shipment.shipmentId) {
      this.$nextTick(() => {
        (this.$refs.addressTo as Address).wineProductChanged();
        (this.$refs.calculator as Calculator).onWineProductChange();
        (this.$refs.mbeService as MBEService).wineProductChanged();
      });
      if (
        this.isUSWineProduct(oldValue) &&
        ["wine_all", "spirits_all"].includes(newValue)
      ) {
        this.shipment.addressFrom = new AddressShipmentDTO();
        // setAddressAsHome() falls back to the store address when the flag is off,
        // so it has to be checked here too: this guard is not redundant
        if (this.useCustomerAddressAsSender) {
          this.setAddressAsHome("addressFrom");
        }
      }
      if (!this.isUSWineProduct(newValue)) return;
      if (!this.isUSWineProduct(oldValue)) {
        // the guard below reads a filled sender as "the importer is already loaded",
        // so entering a US product has to clear what the prefill put there
        this.shipment.addressFrom = new AddressShipmentDTO();
      }
      if (
        this.shipment.addressFrom.address.length ||
        this.shipment.addressFrom.city.length
      )
        return;
      this.shipment.shipmentType = "INTRAWW";
      this.onSubCountryChange();
    } else {
      if (
        this.isWineShipment &&
        this.wineProductUS &&
        this.shipment.mbeService
      ) {
        this.selectWineCourierAndService(true);
      }
    }
  }

  get wineProductUS() {
    return this.isUSWineProduct(this.dimensionWineProductType);
  }

  isUSWineProduct(product: string | null) {
    return product === "wine_us" || product === "spirits_us";
  }

  @Watch("shipment.addressTo.province")
  @Watch("shipment.mbeService")
  async onSubCountryChange() {
    if (this.isWineShipment && this.wineProductUS && this.shipment.mbeService) {
      try {
        this.warehouseSelected = this.wineDefaultWarehouses[
          this.shipment.addressTo.province
        ];
        if (this.warehouseSelected) {
          const res: any = await ShipmentService.prototype.getWine2ImporterById(
            this.warehouseSelected.wineWarehouseId
          );
          this.shipment.addressFrom = new AddressShipmentDTO();
          this.shipment.addressFrom.companyName = `${res.code} - ${res.description}`;
          this.shipment.addressFrom.address = res.address;
          this.shipment.addressFrom.zipCode = res.postcode;
          this.shipment.addressFrom.city = res.city;
          this.shipment.addressFrom.province = (res.state || "").trim();
          this.shipment.addressFrom.contact = res.reference;
          this.shipment.addressFrom.phone = res.phone;
          this.shipment.addressFrom.email = res.email;

          AddressShipmentDTO.trimStrings(this.shipment.addressFrom);

          const countryFound = this.countries.find(
            (el: any) => el.id === res.country
          );
          this.shipment.addressFrom.countryId = countryFound.id;
          this.shipment.addressFrom.countryName = countryFound.name;
          (this.$refs.addressFrom as Address).loadSubcountries();
          await this.selectWineCourierAndService();
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  async selectWineCourierAndService(firstDraftOpen = false) {
    if (this.canSelectCourier || this.canSelectCourierServices) {
      this.warehouseSelected = this.wineDefaultWarehouses[
        this.shipment.addressTo.province
      ];
      const courierService = await PriceListService.prototype.getWineCourierService(
        this.warehouseSelected.wineCourierCode,
        this.shipment.mbeServiceId === 2 ? "STD" : "EXP"
      );
      this.wineCourierService = cloneDeep(courierService);
      (this.$refs.calculator as Calculator).couriers = [
        {
          idCourier: this.wineCourierService.idCourier,
          idMBEBusiness: this.wineCourierService.courierBusinessId,
          courierName: this.wineCourierService.courierName
        }
      ] as CourierDTO[];
      if (firstDraftOpen) {
        (this.$refs.calculator as Calculator).courier = (this.$refs
          .calculator as Calculator).couriers[0];
      } else {
        (this.$refs.calculator as Calculator).courierModified(
          (this.$refs.calculator as Calculator).couriers[0],
          false
        );
      }
      this.$nextTick(() => {
        (this.$refs.calculator as Calculator).courierServices = [
          (this.wineCourierService as unknown) as CourierServiceDTO
        ];
        if (firstDraftOpen) {
          (this.$refs.calculator as Calculator).courierService = (this.$refs
            .calculator as Calculator).courierServices[0];
        } else {
          (this.$refs.calculator as Calculator).courierServiceModified(
            (this.$refs.calculator as Calculator).courierServices[0],
            false
          );
        }
      });
    }
  }

  @Watch("shipment.pickupRequested")
  onChangePickupCheckbox() {
    this.shipment.pickupRequest = this.shipment.pickupRequested;
    if (this.shipment.pickupRequested == true) {
      if (this.$store.getters.customer.config.pickupData) {
        this.shipment.pickup.note = this.$store.getters.customer.config.pickupData.pickupDto.note;
        this.shipment.pickup.alternativeFrom = this.$store.getters.customer.config.pickupData.pickupDto.alternativeFrom;
        this.shipment.pickup.alternativeTo = this.$store.getters.customer.config.pickupData.pickupDto.alternativeTo;
        this.shipment.pickup.preferredFrom = this.$store.getters.customer.config.pickupData.pickupDto.preferredFrom;
        this.shipment.pickup.preferredTo = this.$store.getters.customer.config.pickupData.pickupDto.preferredTo;
      }
    }
  }

  async mounted() {
    const serviceIdList: any[] = [];
    this.serviceId.forEach(item => serviceIdList.push(item.courierServiceId));
    const result = await PriceListService.couriersByIdService(
      serviceIdList.join(",")
    );
    result.forEach(item => {
      this.availablePickup.push(item);
    });

    this.$nextTick(async () => {
      await this.init();
      setTimeout(() => {
        this.initResetZonos = true;
      }, 5750);
    });
  }

  async init() {
    if (
      this.showTaxDutyLogic &&
      this.shipment.proforma &&
      this.shipment.proforma.incoterms === "DDP" &&
      !this.edition &&
      this.hasId
    ) {
      this.disableDDPOptions = true;
    }
    const promises = [];
    const currencies = getCurrencies().then(res => {
      this.currencies = res;
      this.currency = this.$store.getters["customer/storeInfo"].store.currency;
      if (
        this.shipment.shipmentId &&
        this.shipment.proforma &&
        this.shipment.proforma?.currency
      ) {
        //load all currencies and set proforma for edit mode
        const find = this.currencies.find(
          value => value.code === this.shipment.proforma?.currency
        );
        if (find) {
          this.proformaCurrency = find;
        }
      } else if (this.shipment.proforma && this.shipment.proforma?.currency) {
        //load all currencies and set proforma for edit mode
        const find = this.currencies.find(
          value => value.code === this.currency
        );
        if (find) {
          this.proformaCurrency = find;
        }
      }
    });
    promises.push(currencies);

    promises.push(
      store.cache
        .dispatch("cachemod/getAllSubcountries", null, {
          timeout: store.state["cachemod"].timeouts.subCountries
        })
        .then((res: SubcountryDTO[]) => {
          this.allSubCountries = res;
        })
    );
    if (this.edition) {
      const countries = store.cache
        .dispatch("cachemod/getCountries")
        .then((countries: CountryDTO[]) => {
          countries.sort((a: CountryDTO, b: CountryDTO) =>
            a.name < b.name ? -1 : 1
          );
          this.countries = countries
            .map(
              (country: CountryDTO): TranslatedCountryDTO => {
                const translatedCountry = {
                  ...country
                } as TranslatedCountryDTO;
                translatedCountry.translatedName = this.$t(
                  "country_" + country.id
                ).toString();
                return translatedCountry;
              }
            )
            .sort(fieldSorter(["translatedName"]));
        })
        .catch(() => {
          this.$snotify.error(this.$t("error_getting_countries").toString());
        });
      promises.push(countries);
    } else {
      this.countries.push({
        id: `addressFrom_${this.shipment.addressFrom.countryId}`,
        name: this.shipment.addressFrom.countryName,
        translatedName: this.$t(
          "country_" + this.shipment.addressFrom.countryId
        )
      } as TranslatedCountryDTO);
      this.countries.push({
        id: `addressTo_${this.shipment.addressTo.countryId}`,
        name: this.shipment.addressTo.countryName,
        translatedName: this.$t("country_" + this.shipment.addressTo.countryId)
      } as TranslatedCountryDTO);
    }

    if (this.newCreatedShipment) {
      this.$snotify.success(
        this.$t("notification_shipment_created").toString()
      );
    }

    if (this.editedShipment) {
      this.$snotify.error(this.$t("notification_shipment_saved").toString());
    }
    if (!this.shipment.addressStore.companyName) {
      const storeAddresses = this.$store.getters["customer/storeAddresses"];
      const storeName = getStoreCompanyName(
        this.$store.getters["customer/storeInfo"].store.multiStore
      );
      if (storeAddresses.length >= 1) {
        this.shipment.addressStore = await AddressShipmentDTO.fromAddressDTO(
          storeAddresses[0],
          storeName,
          "",
          "NATIONAL",
          this.$store.getters["customer/storeInfo"].contactReferences
        );
      }
    }
    await Promise.all(promises).finally(async () => {
      this.initDone = true;
      if (!this.edition) {
        await this.loadCODPayments();
      }
    });

    ShipmentService.prototype
      .getPricelistKeys(
        "DISABLE_MBE_PRICELIST_FOR_SHIPMENT_CREATED_BY_CUSTOMER",
        this.$store.getters["customer/info"].customerId,
        true
      )
      .then((res: ConfigurationDTO[]) => {
        if (res.length !== 0) {
          this.disabledMbePricelist = res[0].confValue === "true";
        } else {
          this.disabledMbePricelist = false;
        }
      });
  }

  initMbePickupManual() {
    const mbePickupManual = this.$store.getters["customer/config"]
      .mbePickupManual;
    if (
      (!this.shipment || this.shipment.mbePickupManual === undefined) &&
      mbePickupManual !== undefined
    ) {
      this.shipment.mbePickupManual = mbePickupManual;
    }
  }

  async created() {
    if (this.isWineShipment) {
      this.wineDefaultWarehouses = await ShipmentService.prototype.getDefaultWineImporter(
        getStoreId()
      );
    }

    for (const product of this.shipment.shipMBEProducts) {
      switch (product.idSpecialtyBusiness) {
        case 6:
          this.dimensionWineProductType = "wine_us";
          break;
        case 8:
          this.dimensionWineProductType = "spirits_us";
          break;
        case 9:
          this.dimensionWineProductType = "wine_all";
          break;
        case 10:
          this.dimensionWineProductType = "spirits_all";
          break;
      }
    }

    await PriceListService.getMbePackTypes().then((res: any) => {
      this.packTypes = res;
    });
    await ShipmentService.prototype.getTaxAndDutyKeys().then((res: any) => {
      this.isTaxDutyStoreEnabled = getKeyValueConfig(
        res,
        "TAX_AND_DUTIES_ACTIVE"
      );
      this.isTaxDutyZonosStoreEnabled = getKeyValueConfig(
        res,
        "TAX_AND_DUTIES_ZONOS_ACTIVE"
      );
      this.isToUSAPopup = getKeyValueConfig(
        res,
        "SYS_ACTIVATION_PRIOR_NOTICE_POPUP"
      );
    });
    const keyModel: any[] = [];
    keyModel.push(
      {
        tenantId: getTenantId(),
        confKey: "SAFE_VALUE_ESSENTIALS_ENABLED"
      } as ConfigurationDTO,
      {
        tenantId: getTenantId(),
        multistoreId: getMultiStoreId(),
        storeId: getStoreId(),
        confKey: "AUTOFILL_PROFORMA_FIELDS"
      } as ConfigurationDTO
    );
    await ShipmentService.prototype
      .getShipmentKeys(keyModel)
      .then((res: ConfigurationDTO[]) => {
        this.removeEssential = !getKeyValueConfig(
          res,
          "SAFE_VALUE_ESSENTIALS_ENABLED"
        );
        this.disableGoodsValueLock = getKeyValueConfig(
          res,
          "AUTOFILL_PROFORMA_FIELDS"
        );
      });

    await ShipmentService.getPickupCouriers().then((res: any) => {
      this.serviceId = res;
      this.courierPickupEmpty = res === null;
    });
    this.departmentSelected = this.shipment.customerDepartment;

    this.selectedToCountry = {
      value: this.shipment.addressTo.countryId,
      label: this.shipment.addressTo.countryName,
      labelTranslated: String(
        i18n.t("country_" + this.shipment.addressTo.countryId)
      )
    };

    this.initMbePickupManual();

    if (this.isWineShipment && !this.shipment.shipmentId) {
      this.shipment.addressFrom = new AddressShipmentDTO();
      // created() resumes after the children have already filled the sender, so re-apply it here.
      // US products stay empty: onSubCountryChange puts the importer in later
      if (this.useCustomerAddressAsSender && !this.wineProductUS) {
        this.setAddressAsHome("addressFrom");
      }
      this.shipment.shipPackType = "Package";
      this.shipment.courierShipPackType = "Package";
      this.fixPackagesWinePackType();
    }

    if (this.isWineShipment && this.shipment.shipmentId) {
      (this.$refs
        .calculator as Calculator).totalBottles = this.shipment.shipmentPackages
        .map(item => Number(item.itemsNumber) || 0)
        .reduce((a, b) => a + b, 0);
    }
    this.onCourierChange();
    this.checkPaperlessPostClosure();
  }

  async checkPaperlessPostClosure() {
    if (
      this.edition ||
      this.shipment.status !== "DRAFT_NO_WAYBILL" ||
      !this.$store.getters["customer/config"].enablePaperlessPostClosure ||
      !store.getters.features.storePaperlessEnabled ||
      this.hidePaperless
    ) {
      return;
    }
    // Same rule used when creating the shipment: paperless only applies to extra-EU shipments
    if (
      (this.shipment.addressFrom.macroareaName !== "WORLDWIDE" &&
        this.shipment.addressTo.macroareaName !== "WORLDWIDE" &&
        !this.shipmentWithCee() &&
        !this.isNorthIrelandEu()) ||
      this.isSameSubcountry()
    ) {
      return;
    }
    const paperlessEnabled = await ShipmentService.prototype.verifyPaperlessUsage(
      this.shipment.courierId
    );
    if (!paperlessEnabled) return;
    this.paperlessPostClosure = await this.lockShipmentForPaperless();
    if (this.paperlessPostClosure) {
      this.shipment.sentPaperlessDocument = hasPaperlessDocuments(
        this.shipment.paperlessDocumentIds
      );
    }
  }

  // The store must not finalize the shipment on HUB while the customer works on paperless documents
  async lockShipmentForPaperless(): Promise<boolean> {
    try {
      const [res] = await ShipmentService.lockShipments([
        this.shipment.shipmentId
      ]);
      if (
        !res ||
        (res.messages &&
          res.messages.some(message => message.responseType === "ERROR"))
      ) {
        this.$snotify.warning(
          this.$t("paperless_shipment_locked_by_store").toString()
        );
        return false;
      }
      this.shipmentLockedForPaperless = true;
      window.addEventListener("beforeunload", this.unlockShipmentOnUnload);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  }

  unlockShipmentOnUnload() {
    ShipmentService.unlockShipmentsOnUnload([this.shipment.shipmentId]);
    this.shipmentLockedForPaperless = false;
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unlockShipmentOnUnload);
    if (this.shipmentLockedForPaperless) {
      ShipmentService.unlockShipments([this.shipment.shipmentId]).catch(err =>
        console.error(err)
      );
    }
  }

  fixPackagesWinePackType() {
    if (!this.isWineShipment) return;
    this.shipment.shipmentPackages = this.shipment.shipmentPackages.map(
      (el: any) => {
        return Object.assign(el, {
          winePackType: el.winePackType ? el.winePackType : "STANDARD"
        });
      }
    );
  }

  @Emit("clearFields")
  clearFields(shipmentType: string) {
    return shipmentType;
  }

  openSearchModal(addressData) {
    this.modalSearchContactOptions.addressData = addressData;
    this.searchContactModalVisible = true;
    this.searchContactModalSource = "receiver";
  }

  openSearchModalSender(addressData) {
    this.modalSearchContactOptions.addressData = addressData;
    this.searchContactModalVisible = true;
    this.searchContactModalSource = "sender";
  }

  onCloseAccessPointsModal() {
    this.showAccessPointsModal = false;
  }

  changeGoodType(value: boolean) {
    if (value) {
      this.shipment.goodType = "GOODS";
      this.shipment.goodTypeId = 1;
    } else {
      this.shipment.goodType = "ESSENTIAL";
      this.shipment.goodTypeId = 20;
    }
  }

  get zonosProforma() {
    if (
      !this.shipment.proforma ||
      !this.shipment.proforma.proformaDetails ||
      !this.shipment.proforma.proformaDetails.length
    )
      return null;
    const items = this.shipment.proforma.proformaDetails.map(
      (item: ProformaDetailsDTO) => {
        const hsCode = item.hsCode ? item.hsCode : null;
        const category = item.category ? item.category : "";
        const gender = item.gender ? item.gender : "";
        const material = item.material ? item.material : "";
        return Object.assign(item, {
          currency: this.shipment.proforma.currency,
          hsCode,
          category,
          gender,
          material
        });
      }
    ) as ZonosProformaDetailsDTO[];
    return {
      items,
      languageCode: this.shipment.proforma.language,
      currency: this.shipment.proforma.currency,
      shipFromCountry: this.shipment.addressFrom.countryId,
      shipToCity: this.shipment.addressTo.city,
      shipToCountry: this.shipment.addressTo.countryId,
      shipToPostalCode: this.shipment.addressTo.zipCode,
      shipToState: this.shipment.addressTo.province,
      shippingAmount: (this.prices && this.prices.totalCost) || 0,
      shippingAmountDiscount: 0,
      courierServiceId: this.courierServiceId,
      incoterms: this.shipment.proforma.incoterms || ""
    } as ZonosProformaDTO;
  }

  resetTaxDutyData() {
    this.$store.commit("shipment/setZonosInvalidItems", []);
    this.$store.commit("shipment/setZonosCalculateResponse", null);
    this.zonosTotalCost = "";
  }
  isNorthIrelandEu() {
    if (
      this.irelandMacroarea(this.shipment.addressFrom) &&
      !this.irelandMacroarea(this.shipment.addressTo)
    )
      return true;
    if (
      !this.irelandMacroarea(this.shipment.addressFrom) &&
      this.irelandMacroarea(this.shipment.addressTo)
    )
      return true;
    return false;
  }
  irelandMacroarea(address: any) {
    return address.macroareaName == "TRANSBORDER" && address.countryId == "GB";
  }

  @Watch("zonosCalculateCalled")
  onZonosCalculateCalled(status: boolean) {
    if (!status) return;
    if (!this.zonosCalculateResponse)
      throw new Error("Zonos Calculate response is not set!");
    if (
      this.zonosCalculateResponse.items &&
      this.shipment.proforma.proformaDetails
    ) {
      this.shipment.proforma.proformaDetails = this.shipment.proforma.proformaDetails.map(
        (el: ProformaDetailsDTO) => {
          const foundItem = this.zonosCalculateResponse.items.find(
            (item: ZonosCalculateResponseItemDTO) =>
              item.position === el.position
          );
          if (foundItem) {
            el.hsCode = foundItem.hsCode;
          }
          return el;
        }
      );
    }
    if (!this.zonosCalculateResponse.costGuaranteed) {
      const zonosInvalidItems = cloneDeep(
        this.zonosCalculateResponse
      ).items.filter((el: ZonosCalculateResponseItemDTO) => el.restricted);
      this.$store.commit("shipment/setZonosInvalidItems", zonosInvalidItems);
      this.disableDDPOptions = false;
      this.disableZonosDDP = true;
      if (this.shipment.ddpZonos) {
        this.shipment.customsDutiesToCustomer = false;
        this.shipment.requestedChargeCustomDuties = false;
        this.shipment.ddpZonos = false;
        this.zonosTotalCost = "";
        if (zonosInvalidItems && zonosInvalidItems.length > 0) {
          const invalidHsCodes = zonosInvalidItems.map(
            (el: ZonosCalculateResponseItemDTO) => el.hsCode
          );
          this.zonosCalculateCalled = false;
          return this.$alerts.danger(
            String(
              i18n.t("TAX-DUTY-CALCULATION-INVALID-ITEMS-WARNING", {
                items: invalidHsCodes.join(",")
              })
            )
          );
        }
      }
    } else {
      this.$store.commit("shipment/setZonosInvalidItems", []);
      // this.shipment.customsDutiesToCustomer = false;
      if (!this.isProformaDDP) {
        this.shipment.requestedChargeCustomDuties = false;
        this.shipment.customsDutiesToCustomer = false;
        this.shipment.ddpZonos = false;
        this.disableDDPOptions = false;
        this.disableZonosDDP = false;
      } else {
        if (
          !this.shipment.customsDutiesToCustomer &&
          !this.shipment.requestedChargeCustomDuties &&
          !this.shipment.ddpZonos
        ) {
          this.shipment.ddpZonos = true;
        }
      }
    }
    this.zonosCalculateCalled = false;
  }

  async calculateTaxDuty() {
    try {
      if (!this.courierServiceId) {
        return this.$alerts.danger(
          String(i18n.t("TAX-DUTY-CALCULATION-MISSING-COURIER-SERVICE-ID"))
        );
      }

      if (!this.shipment.customerWeight) {
        return this.$alerts.danger(
          String(i18n.t("TAX-DUTY-CALCULATION-MISSING-COURIER-WEIGHT"))
        );
      }
      if (this.zonosProforma === null)
        throw new Error("Missing required calculate param");

      const missingPositionId = this.zonosProforma.items.some(
        (el: ZonosProformaDetailsDTO) => !el.position
      );
      if (missingPositionId) {
        return this.$alerts.danger(
          String(i18n.t("TAX-DUTY-CALCULATION-MISSING-POSITION-ID"))
        );
      }

      this.taxAndDutyExternalCall = true;
      await this.recalculatePrice();
      this.hideDDPValues = false;
      this.calculateTaxDutyBtnTriggered = true;
    } catch (err) {
      if (err.response && err.response.data && err.response.data.code) {
        switch (err.response.data.code) {
          case "INCOTERMS_NOT_SUPPORTED":
            return this.$alerts.danger(
              String(i18n.t("TAX-DUTY-CALCULATION-INCOTERMS-NOT-SUPPORTED"))
            );
          case "COURIER_SERVICE_NOT_SUPPORTED":
            this.disableDDPOptions = false;
            if (this.shipment.proforma.incoterms !== "DDP") {
              this.shipment.requestedChargeCustomDuties = false;
              this.disableDDPOptions = false;
            } else {
              this.shipment.requestedChargeCustomDuties = true;
            }
            return this.$alerts.danger(
              String(
                i18n.t("TAX-DUTY-CALCULATION-COURIER-SERVICE-NOT-SUPPORTED")
              )
            );
        }
      }
      this.zonosTotalCost = "";
      console.error(err);
    }
  }

  get deliveryPointExportAllowedInHub() {
    const visibilities = this.$store.getters[
      "customer/courierVisibilityConfig"
    ];
    const visibleServices = visibilities.filter((item: any) => {
      return (
        item.courierServiceId === 0 &&
        item.mbeServiceId === 219 &&
        item.shipmentType == "EXPORT"
      );
    });

    return visibleServices.length > 0;
  }

  @Watch("courierServiceId")
  onCourierServiceIdChange(id: any, oldId: any) {
    if (id === oldId || !this.initResetZonos) return;
    this.resetZonosData("courierServiceId", true);
  }

  get courierServiceId() {
    if (this.shipment && this.shipment.courierServiceId)
      return this.shipment.courierServiceId;
    if (this.prices && this.prices.courierServiceBusinessId)
      return this.prices.courierServiceBusinessId;
    return 0;
  }

  onAccessPointSelected(event: AddressLocatorDto) {
    this.$emit("updateShipmentAccessPoint", event);
    const country = this.countryValues.find(
      (country: any) => country.value === event.countryId
    );
    if (country) {
      this.updateToCountry(country, this.shipment.addressTo.subcountryId);
    }

    this.shipment.addressTo.address = event.address;
    this.shipment.addressTo.secondAddress = event.secondAddress;
    this.shipment.addressTo.thirdAddress = event.thirdAddress;
    this.shipment.addressTo.city = event.city;
    this.shipment.addressTo.countryId = event.countryId;
    this.shipment.addressTo.companyName = event.locatorName;
    this.shipment.addressTo.zipCode = event.zipCode;
    this.shipment.addressTo.province = (event.province || "").trim();
    AddressShipmentDTO.trimStrings(this.shipment.addressTo);
    const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
      .zipCode;
    const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
      .countryId;
    this.$store.cache
      .dispatch(
        "cachemod/getSubcountries",
        {
          countryId: this.shipment.addressTo.countryId,
          zipcode: this.shipment.addressTo.zipCode,
          storeZipCode: storeZipCode,
          storeIsoCode: storeIsoCode
        },
        { timeout: this.$store.state["cachemod"].timeouts.subCountries }
      )
      .then((res: SubcountryDTO[]) => {
        this.shipment.addressTo.subcountry = res[0].description;
        this.shipment.addressTo.subcountryId = res[0].idSubcountry;
        this.shipment.addressTo.macroareaName = res[0].macroareaName;
      });
  }

  handleSelectedPaperlessChange(selected: number[]) {
    if (selected.length > 0) {
      this.shipment.paperlessDocumentIds = selected;
    } else {
      this.shipment.paperlessDocumentIds = undefined;
    }
  }

  async toggleAddPaperlessModal() {
    this.showAddPaperlessModal = !this.showAddPaperlessModal;
  }

  findSubcountryById(idSubcountry: number): SubcountryDTO {
    return this.allSubCountries.filter(
      value => idSubcountry === value.idSubcountry
    )[0];
  }

  updateToCountry(value: SelectOptionDef, subcountryValue?: any) {
    let subcountryName = "";
    if (subcountryValue) {
      const filteredSubcountry = this.findSubcountryById(subcountryValue);
      if (filteredSubcountry) {
        subcountryName = filteredSubcountry.description;
      }
    }
    if (this.edition) return;
    if (this.selectedToCountry.value != value.value)
      this.selectedToCountry = value;

    this.shipment.addressTo.countryName = this.selectedToCountry.label;
    this.shipment.addressTo.countryId = String(this.selectedToCountry.value);
    this.shipment.addressTo.subcountry = subcountryName;
    this.shipment.addressTo.subcountryId = subcountryValue || 0;
    if (value.value === "IT") {
      this.shipment.addressTo.province = this.shipment.addressTo.province
        ? this.shipment.addressTo.province.trim().toUpperCase()
        : this.shipment.addressTo.province;
    }
  }

  fillContact(contact: ContactDTO, address: AddressDTO) {
    if (
      (address.countryName == "" || !address.countryName) &&
      address.countryId
    ) {
      this.countries.forEach(c => {
        if (address.countryId == c.id) {
          address.countryName = c.name;
        }
      });
    }
    if (this.searchContactModalSource === "sender") {
      this.shipment.addressFrom = AddressShipmentDTO.fromContactDTO(
        contact,
        address,
        this.$store.getters["customer/info"].vatNumber,
        "",
        undefined,
        this.$store.getters["customer/info"].eori,
        this.$store.getters["customer/info"].fiscalCode
      );
      this.calculateMacroAreaForAddress("addressFrom");
      (this.$refs.addressFrom as Address).forceReload();
      this.$emit("senderAddressLoaded", contact);
    } else if (this.searchContactModalSource === "receiver") {
      const addressTo = AddressShipmentDTO.fromContactDTO(
        contact,
        address,
        this.$store.getters["customer/info"].vatNumber,
        "",
        undefined,
        this.$store.getters["customer/info"].eori,
        this.$store.getters["customer/info"].fiscalCode
      );
      const shipment = cloneDeep({
        ...this.shipment,
        addressTo,
        mbeServiceId: 0,
        mbeService: "",
        addressAccessPoint: undefined
      });
      this.recalculatePrice();
      this.$emit("updateShipment", shipment);
      this.$nextTick(() => {
        this.calculateMacroAreaForAddress("addressTo");
        this.$emit("receiverAddressLoaded", contact);
        (this.$refs.addressTo as Address).forceReload();
      });
      this.isDeliveryPointSelected = false;
    }
    this.searchContactModalVisible = false;
    this.searchContactModalSource = "";
  }

  prefillAddressesAfterShipmentTypeChanged() {
    if (
      this.shipment.shipmentType === "EXPORT" ||
      this.shipment.shipmentType === "DOMESTIC"
    ) {
      this.setAddressAsHome("addressFrom");
      this.shipment.addressTo = new AddressShipmentDTO();
      if (this.shipment.shipmentType === "DOMESTIC") {
        this.shipment.addressTo.countryId = this.$store.getters[
          "customer/storeAddresses"
        ][0].countryId;
        this.shipment.addressTo.countryName = this.$store.getters[
          "customer/storeAddresses"
        ][0].countryName;
      }
    } else {
      // IMPORT
      this.setAddressAsHome("addressTo");
      this.shipment.addressFrom = new AddressShipmentDTO();
    }
  }
  @Watch("shipment.shipmentPackages", { deep: true })
  totalPackageumber() {
    this.shipment.totalNumberOfPackages = this.shipment.shipmentPackages.length;
  }

  setAddressAsHome(direction) {
    const commercialName = getCustomerCommercialName(
      this.$store.getters["customer/info"]
    );
    if (this.useCustomerAddressAsSender) {
      if (this.shipment.customerDepartmentId > 0) {
        const department = this.$store.getters["customer/departments"].filter(
          (item: DepartmentDTO) => {
            return item.departmentId === this.shipment.customerDepartmentId;
          }
        );
        if (department.length > 0) {
          this.shipment[direction] = AddressShipmentDTO.fromAddressDTO(
            department[0].address.addresses[0],
            department[0].departmentBusinessName,
            this.$store.getters["customer/info"].vatNumber,
            "NATIONAL",
            department[0].address.contactsReference,
            this.$store.getters["customer/info"].eori,
            this.$store.getters["customer/info"].fiscalCode
          );
        }
      } else {
        this.shipment[direction] = AddressShipmentDTO.fromCustomerDTO(
          this.$store.getters["customer/info"]
        );
        if (commercialName) {
          this.shipment[direction].companyName = this.$store.getters[
            "customer/info"
          ].commercialName;
        }
      }
    } else {
      const companyName = getStoreCompanyName(
        this.$store.getters["customer/storeInfo"].store.multiStore
      );
      this.shipment[direction] = AddressShipmentDTO.fromAddressDTO(
        this.$store.getters["customer/storeAddresses"][0],
        companyName,
        this.$store.getters["customer/info"].vatNumber,
        "NATIONAL",
        this.$store.getters["customer/storeInfo"].contactReferences,
        this.$store.getters["customer/info"].eori,
        this.$store.getters["customer/info"].fiscalCode
      );

      //Here I need to calculate the subcountry given the store zipcode and country ID
      const shipData = this.shipment[direction];
      const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
        .zipCode;
      const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
        .countryId;
      store.cache
        .dispatch(
          "cachemod/getSubcountries",
          {
            countryId: shipData.countryId,
            zipcode: shipData.zipCode,
            storeZipCode: storeZipCode,
            storeIsoCode: storeIsoCode
          },
          { timeout: store.state["cachemod"].timeouts.subCountries }
        )
        .then((res: SubcountryDTO[]) => {
          shipData.subcountry = res[0].description;
          shipData.subcountryId = res[0].idSubcountry;
        });
    }
    setTimeout(() => {
      if (this.$refs[direction]) {
        (this.$refs[direction] as Address).forceReload();
      }
    }, 10);
  }

  changeAddressTo(type) {
    this.receiverTypeAddress = type;
    if (type === "fromStore") {
      this.setAddressToFromStore();
    } else {
      this.setAddressToFromUser();
    }
    this.recalculatePrice();
  }

  setAddressToFromStore() {
    const companyName = getStoreCompanyName(
      this.$store.getters["customer/storeInfo"].store.multiStore
    );
    this.shipment.addressTo = AddressShipmentDTO.fromAddressDTO(
      this.$store.getters["customer/storeAddresses"][0],
      companyName,
      this.$store.getters["customer/info"].vatNumber,
      "NATIONAL",
      this.$store.getters["customer/storeInfo"].contactReferences,
      this.$store.getters["customer/info"].eori,
      this.$store.getters["customer/info"].fiscalCode
    );
    this.calculateMacroAreaForAddress("addressTo");
  }

  setAddressToFromUser() {
    const customerInfo = this.$store.getters["customer/info"];
    if (
      this.$store.getters["customer/config"].isDepartmentMandatory === false
    ) {
      this.shipment.addressTo = AddressShipmentDTO.fromCustomerDTO(
        customerInfo
      );
      if (getCustomerCommercialName(customerInfo)) {
        this.shipment.addressTo.companyName = getCustomerCommercialName(
          customerInfo
        );
      }
      this.calculateMacroAreaForAddress("addressTo");
    } else {
      (this.$refs.topbar as Topbar).selectCurrentDepartment();
    }
  }

  getErrorsFromRef(ref, entity = "address") {
    return Object.keys((this.$refs[ref] as Vue).$v[entity].$params).filter(
      fieldName => (this.$refs[ref] as Vue).$v[entity][fieldName].$invalid
    );
  }

  get confirmShipmentErrorMessages() {
    return {
      addressFrom_address:
        this.$t("shipment_sender") + " " + this.$t("shipment_address1"),
      addressFrom_companyName:
        this.$t("shipment_sender") + " " + this.$t("business_name"),
      addressFrom_zipCode:
        this.$t("shipment_sender") + " " + this.$t("postal_code"),
      addressFrom_city: this.$t("shipment_sender") + " " + this.$t("city"),
      addressFrom_countryName:
        this.$t("shipment_sender") + " " + this.$t("country"),
      addressFrom_subcountry:
        this.$t("shipment_sender") + " " + this.$t("subcountry"),
      addressFrom_email: this.$t("shipment_sender") + " " + this.$t("email"),
      addressFrom_secondEmail:
        this.$t("shipment_sender") + " " + this.$t("email2"),
      addressFrom_contact:
        this.$t("shipment_sender") + " " + this.$t("shipment_contact_name"),
      addressFrom_phone:
        this.$t("shipment_sender") + " " + this.$t("telephone"),
      addressFrom_secondPhone:
        this.$t("shipment_sender") + " " + this.$t("telephone2"),
      goodDescription: this.$t("shipment_goods_description"),
      mbeService: this.$t("mbeService"),
      addressToAutocomplete_contact:
        this.$t("shipment_receiver") + " " + this.$t("shipment_contact_name"),
      addressToAutocomplete_phone:
        this.$t("shipment_receiver") + " " + this.$t("telephone"),
      addressToAutocomplete_secondPhone:
        this.$t("shipment_receiver") + " " + this.$t("telephone2"),
      addressToAutocomplete_email:
        this.$t("shipment_receiver") + " " + this.$t("email"),
      addressToAutocomplete_secondEmail:
        this.$t("shipment_receiver") + " " + this.$t("email2")
    };
  }

  get packagesAmount() {
    return this.shipment.shipmentPackages.length;
  }

  get hasAccessPointData() {
    return (
      this.shipment.addressAccessPoint &&
      Object.keys(this.shipment.addressAccessPoint).length > 0
    );
  }

  confirmShipment() {
    if (this.isDeliveryPointSelected) {
      const errorMessages = [];
      if (this.packagesAmount > 1) {
        errorMessages.push(`<p>- ${i18n.t("AP2AP_SINGLE_PACKAGE_SET")}</p>`);
      }

      if (!this.hasAccessPointData) {
        errorMessages.push(
          `<p>- ${i18n.t("AP2AP_MISSING_ACCESS_POINT_DESTINATION")}</p>`
        );
      }
      /*
      if (this.hasInvalidPackageDimension) {
        errorMessages.push(`<p>- ${i18n.t("AP2AP_PACKAGE_SIZE_WEIGHT")}</p>`);
      }
*/
      if (
        this.shipment.addressTo.phone.length === 0 ||
        this.shipment.addressTo.email.length === 0 ||
        this.shipment.addressTo.contact.length === 0
      ) {
        errorMessages.push(`<p>- ${i18n.t("AP2AP_MISSING_FIELDS")}</p>`);
      }

      if (errorMessages.length > 0) {
        EventBus.$emit("hide-my-full-loading");
        return AlertBus.$alerts.danger(errorMessages.join(" "));
      }
    }

    let refErrorMessages: string[] = [];
    const stringErrorMessages: string[] = [];
    let errorsSender = [];
    let errorsReceiver = [];
    let errorsNotes = [];
    let errorsService = [];
    if (!this.shipment.pickupRequested) this.shipment.pickup = null;
    this.shipment.proformaValue = this.shipment.proforma
      ? this.shipment.proforma.totalValue
      : undefined;
    if (this.shipment.proforma && !this.shipment.proforma.proformaSenderType) {
      this.watchSenderAddress = true;
      this.addProformaSender();
    }

    if (this.$refs["addressFrom"] !== undefined) {
      errorsSender = this.getErrorsFromRef("addressFrom").map(
        key => `addressFrom_${key}`
      );
    }
    if (this.$refs["addressFromAutocomplete"] !== undefined) {
      errorsSender = this.getErrorsFromRef("addressFromAutocomplete").map(
        key => `addressFrom_${key}`
      );
    }
    if (this.$refs["addressToAutocomplete"] !== undefined) {
      errorsReceiver = this.getErrorsFromRef("addressToAutocomplete").map(
        key => `addressToAutocomplete_${key}`
      );
    }
    if (this.$refs["addressTo"] !== undefined) {
      errorsReceiver = this.getErrorsFromRef("addressTo").map(
        key => `addressToAutocomplete_${key}`
      );
    }
    if (this.$refs["notes"] !== undefined) {
      errorsNotes = this.getErrorsFromRef("notes", "shipment");
    }
    if (
      this.$store.getters["customer/config"].canSelectMBEService &&
      !this.shipment.mbeService
    ) {
      errorsService = ["mbeService"];
    }
    const mergedErrors = [].concat.apply(
      [],
      [errorsSender, errorsReceiver, errorsNotes, errorsService]
    );
    if (mergedErrors.length) {
      refErrorMessages = mergedErrors;
    }
    if (this.$refs["extraServices"] !== undefined) {
      //extraservices by refs
      const extraservicesElement = this.$refs["extraServices"] as ExtraServices;
      const keys = Object.keys(extraservicesElement.$refs);
      if (keys) {
        keys
          .filter(value => value.startsWith("extraService_"))
          .forEach(refKey => {
            const extraServElement = extraservicesElement.$refs[refKey][0];
            if (extraServElement && (extraServElement as Vue).$v.$invalid) {
              stringErrorMessages.push(this.$t(refKey) + "");
            }
          });
      }
    }
    if (!this.validateForm()) {
      if (this.errorMaxPackageWeight) {
        stringErrorMessages.push(
          this.$t("max_package_weight_form_error") +
            this.$store.getters["customer/config"].maxPackageWeight.toFixed(1)
        );
      }
      if (this.errorNoPackageWeight) {
        stringErrorMessages.push(this.$t("no_package_weight_form_error") + "");
      }
      if (this.errorMaxShipmentWeight) {
        stringErrorMessages.push(
          this.$t("max_shipment_weight_form_error") +
            this.$store.getters["customer/config"].maxShipmentWeight.toFixed(1)
        );
      }
      if (this.errorNoShipmentWeight) {
        stringErrorMessages.push(this.$t("no_shipment_weight_form_error") + "");
      }
      if (this.errorMultipackage) {
        stringErrorMessages.push(this.$t("multipackage_form_error") + "");
      }
      if (this.errorMaxSafeValue) {
        stringErrorMessages.push(
          this.$t("max_safe_value_form_error") +
            this.maxSafeValueForCustomer().toFixed(1)
        );
      }
      if (this.errorMaxCod) {
        stringErrorMessages.push(
          this.$t("max_cod_form_error") + this.maxCodForCustomer().toFixed(1)
        );
      }
      if (this.errorMaxInsurance) {
        stringErrorMessages.push(
          this.$t("max_insurance_form_error") +
            this.maxInsuranceForCustomer().toFixed(1)
        );
      }
      if (this.errorMbeServiceAndCalculator.length > 0) {
        stringErrorMessages.push(this.$t("missing_data_to_select") + "");
        this.errorMbeServiceAndCalculator.forEach(item => {
          stringErrorMessages.push(this.$t(item) + "");
        });
      }
      if (this.errorPackageSizeMandatory) {
        stringErrorMessages.push(this.$t("package_size_form_error") + "");
      }
    }
    if (
      this.$store.getters["customer/config"].isDepartmentMandatory &&
      (!this.departmentSelected || this.departmentSelected === "")
    ) {
      stringErrorMessages.push(
        this.$t("IMPORT_ONLINE_INVALID_DEPARTMENT") + ""
      );
    }

    if (refErrorMessages.length > 0 || stringErrorMessages.length > 0) {
      let message = this.$t("generic_shipment_form_error") + "<br><br>";
      refErrorMessages.forEach(key => {
        if (this.confirmShipmentErrorMessages[key] !== undefined) {
          message += `${this.confirmShipmentErrorMessages[key]} <br>`;
        } else {
          message += `${key} <br>`;
        }
      });
      stringErrorMessages.forEach(errMess => {
        message += `${errMess} <br>`;
      });
      console.error(
        "Popup Errors:",
        JSON.parse(JSON.stringify(this.confirmShipmentErrorMessages)),
        JSON.parse(JSON.stringify(refErrorMessages))
      );
      AlertBus.$alerts.danger(message);
    } else {
      if (!isGermany()) {
        if (
          this.shipment.addressTo.countryId == "US" &&
          (this.shipment.addressFrom.macroareaName == "NATIONAL" ||
            this.shipment.addressFrom.macroareaName == "TRANSBORDER") &&
          this.isToUSAPopup
        ) {
          AlertBus.$alerts
            .confirm(i18n.t("PRIOR_NOTICE_NOTIFICATION"))
            .then((resp: boolean) => {
              if (resp) {
                this.$emit("saveShipment");
              }
            });
        } else {
          AlertBus.$alerts
            .confirm(
              this.edition
                ? this.$t("confirm_save_shipment")
                : this.$t("confirm_shipment_creation")
            )
            .then((val: boolean) => {
              if (val) {
                this.$emit("saveShipment");
              }
            });
        }
      } else {
        if (this.canSaveShipment) {
          this.canSaveShipment = false;
          if (
            this.shipment.addressTo.countryId == "US" &&
            (this.shipment.addressFrom.macroareaName == "NATIONAL" ||
              this.shipment.addressFrom.macroareaName == "TRANSBORDER") &&
            this.isToUSAPopup
          ) {
            AlertBus.$alerts
              .confirm(i18n.t("PRIOR_NOTICE_NOTIFICATION"))
              .then((resp: boolean) => {
                if (resp) {
                  this.$emit("saveShipment");
                }
              });
          } else {
            this.$emit("saveShipment");
          }
        }
      }
    }
  }

  @Watch("shipment.addressFrom", { deep: true })
  addProformaSender() {
    if (this.watchSenderAddress) {
      this.shipment.proforma.proformaSenderType = "sender";
      this.shipment.proforma.senderCompanyName =
        this.shipment.addressFrom.companyName || "";
      this.shipment.proforma.senderAddress =
        this.shipment.addressFrom.address || "";
      this.shipment.proforma.senderCity = this.shipment.addressFrom.city || "";
      this.shipment.proforma.senderProvince =
        this.shipment.addressFrom.province || "";
      this.shipment.proforma.senderZipCode =
        this.shipment.addressFrom.zipCode || "";
      this.shipment.proforma.senderCountryName =
        this.shipment.addressFrom.countryName || "";
      this.shipment.proforma.senderCountryId =
        this.shipment.addressFrom.countryId || "";
      this.shipment.proforma.senderPhone =
        this.shipment.addressFrom.phone || "";
      this.shipment.proforma.eori = "";
      this.shipment.proforma.fiscalCode = "";
      this.shipment.proforma.vatNumber = "";
    }
  }

  confirmShipmentDraft() {
    this.$emit("saveDraft");
  }

  cancelToken: any = axios.CancelToken;
  cancelSource: any = undefined;

  paymentTypes: PaymentTypesDTO[] = [];

  validateForm() {
    this.errorMaxPackageWeight = false;
    this.errorNoPackageWeight = false;
    this.errorMaxShipmentWeight = false;
    this.errorNoShipmentWeight = false;
    this.errorMultipackage = false;
    this.errorPackageSizeMandatory = false;
    this.errorMaxSafeValue = false;
    this.errorMaxCod = false;
    this.errorMaxInsurance = false;
    this.errorMbeServiceAndCalculator = [];

    const invalidAddress = this.isInboundShipment
      ? (this.$refs.addressToAutocomplete as AddressAutocomplete).$v.$invalid
      : this.$refs.addressTo === undefined ||
        (this.$refs.addressTo as Address).$v.$invalid;
    let invalidPackageDefinitions = false;

    if (
      this.$refs.calculator === undefined ||
      (this.$refs.calculator as Calculator).$refs.packageDefinitions ===
        undefined
    ) {
      invalidPackageDefinitions = true;
    } else if ((this.$refs.calculator as Calculator).$v.$invalid) {
      if ((this.$refs.calculator as Calculator).isErrorMaxShipmentWeight()) {
        this.errorMaxShipmentWeight = true;
      }
      if ((this.$refs.calculator as Calculator).isErrorNoShipmentWeight()) {
        this.errorNoShipmentWeight = true;
      }
      if ((this.$refs.calculator as Calculator).isErrorMultipackage()) {
        this.errorMultipackage = true;
      }
      invalidPackageDefinitions = true;
    } else {
      ((this.$refs.calculator as Calculator).$refs
        .packageDefinitions as PackageDefinition[]).forEach(
        (packageDefinition: PackageDefinition) => {
          if (packageDefinition.$v.$invalid) {
            if (
              packageDefinition.isErrorPackageSizeMandatory() &&
              this.shipment.shipPackType !== "Envelope" &&
              this.shipment.shipPackType !== "Documents"
            ) {
              this.errorPackageSizeMandatory = true;
            }
            if (packageDefinition.isErrorMaxPackageWeight()) {
              this.errorMaxPackageWeight = true;
            }
            if (packageDefinition.isErrorNoPackageWeight()) {
              this.errorNoPackageWeight = true;
            }
            invalidPackageDefinitions = true;
          }
        }
      );
    }
    this.shipment.shipmentPackages.forEach(item => {
      if (
        (item.depth > 0 || item.width > 0 || item.height > 0) &&
        (!item.depth || !item.width || !item.height)
      ) {
        this.errorPackageSizeMandatory = true;
        invalidPackageDefinitions = true;
      }
    });
    const invalidNotes =
      this.$refs.notes === undefined || (this.$refs.notes as Notes).$v.$invalid
        ? true
        : false;
    let invalidExtraServices = false;
    if (this.$refs.extraServices === undefined) {
      invalidExtraServices = true;
    }
    if (
      !(this.$refs.extraServices as ExtraServices).validateExtraService(
        MBE_SAFE_VALUE
      )
    ) {
      this.errorMaxSafeValue = true;
      invalidExtraServices = true;
    }
    if (
      !(this.$refs.extraServices as ExtraServices).validateExtraService(COD)
    ) {
      this.errorMaxCod = true;
      invalidExtraServices = true;
    }
    if (
      !(this.$refs.extraServices as ExtraServices).validateExtraService(
        INSURANCE_COURIER
      )
    ) {
      this.errorMaxInsurance = true;
      invalidExtraServices = true;
    }

    let invalidProforma = false;
    invalidProforma = this.$v.$invalid;

    return !(
      invalidAddress ||
      invalidPackageDefinitions ||
      invalidNotes ||
      invalidExtraServices ||
      invalidProforma ||
      this.errorMbeServiceAndCalculator.length > 0
    );
  }

  blockRecalculatePrice = false;

  newWineShipment2(product) {
    this.dimensionWineProductType = product;
  }

  @Debounce(1500)
  async recalculatePrice(): Promise<any> {
    let autopilotParameter = false;
    this.shipment.storeCity = this.$store.getters[
      "customer/storeAddresses"
    ][0].city;
    this.shipment.storeZipCode = this.$store.getters[
      "customer/storeAddresses"
    ][0].zipCode;
    if (!this.edition && !this.showTaxDutyLogic) {
      //skip details/recalculate on non-editable shipments
      return;
    }
    if (this.blockRecalculatePrice) {
      return;
    }
    const d: ShipmentDetailsInputDTO = {} as ShipmentDetailsInputDTO;
    const s = this.shipment;
    if (
      this.useCustomerAddressAsSender &&
      this.$store.state.customer.config.thirdPartySurcharge == false
    ) {
      const extraService = {
        extraServiceName: "Third Party Shipment",
        mbeBusinessId: 106,
        surcharge: true,
        order: 99,
        description: "Third Party Shipment"
      } as any;
      if (extraService) {
        extraService.dismissed = true;
        extraService.price = false;
        extraService.cost = false;
        if (
          !this.shipment.dismissedExtraServices.find(
            diss => diss.extraServiceName == "Third Party Shipment"
          )
        ) {
          (this.shipment.dismissedExtraServices as any).push(extraService);
        }
      }
    }

    if (s.addressFrom.city !== "") {
      d.cityFrom = s.addressFrom.city;
    } else {
      return;
    }
    if (s.addressTo.city !== "") {
      d.cityTo = s.addressTo.city;
    } else {
      return;
    }
    if (s.addressFrom) {
      d.addressFrom = s.addressFrom;
    } else {
      return;
    }
    if (s.addressTo) {
      d.addressTo = s.addressTo;
    }
    if (s.addressStore) {
      d.addressStore = s.addressStore;
    } else {
      return;
    }
    if (s.addressTo.countryId !== "") {
      d.idCountryTo = s.addressTo.countryId;
    } else {
      return;
    }
    if (this.$store.getters["customer/storeInfo"].store.zone) {
      d.countryCode = this.$store.getters[
        "customer/storeInfo"
      ].store.zone.country;
    } else {
      return;
    }
    if (s.addressFrom.countryId !== "") {
      d.idCountryFrom = s.addressFrom.countryId;
    } else {
      return;
    }
    if (this.canRequestCustomDuties || this.showTaxDutyLogic) {
      d.customsDutiesToCustomer = s.customsDutiesToCustomer;
      d.requestedChargeCustomDuties = s.requestedChargeCustomDuties;

      d.addressTo = s.addressTo;
      d.addressFrom = s.addressFrom;
      d.addressStore = s.addressStore;
    } else {
      this.shipment.customsDutiesToCustomer = false;
    }
    if (this.isCourierTNT) {
      this.shipment.customsDutiesToCustomer = false;
    }
    d.storeCity = s.storeCity;
    d.storeZipCode = s.storeZipCode;
    d.idMBECustomer = this.$store.getters["customer/info"].customerMbeId;
    d.idStore = this.$store.getters["customer/storeInfo"].store.id;
    d.idMultistore = getMultiStoreId();
    if (s.addressFrom.subcountryId !== 0) {
      d.idSubcountryFrom = s.addressFrom.subcountryId;
    } else {
      return;
    }
    if (s.addressTo.subcountryId !== 0) {
      d.idSubcountryTo = s.addressTo.subcountryId;
    } else {
      return;
    }
    if (s.addressFrom.zipCode !== "") {
      d.zipCodeFrom = s.addressFrom.zipCode;
    } else {
      return;
    }
    if (s.addressTo.zipCode !== "") {
      d.zipCodeTo = s.addressTo.zipCode;
    }
    if (s.distanceFromTo) {
      d.distance = s.distanceFromTo;
    } else {
      d.distance = undefined;
    }
    d.shipType = s.shipmentType;
    d.goodTypeId = s.goodTypeId;
    d.mbePackTypeIdBusiness = s.shipPackTypeId;
    if (this.autopilotEnabled && this.updateAutopilot && !this.isGel) {
      await PriceListService.getAutopilotMBEServices(d)
        .then((res: number[]) => {
          this.autopilotAvailableMbeServices = res;
          if (res.includes(this.oldMbeServiceId)) {
            this.shipment.mbeServiceId = this.oldMbeServiceId;
            this.shipment.mbeService = this.oldMbeService;
          }
          this.oldMbeServiceId = undefined;
          this.oldMbeService = undefined;
          if (res.length == 0) {
            this.resetCourierData();
            this.resetCourierServiceData();
            (this.$refs.calculator as Calculator).couriers = [];
            (this.$refs.calculator as Calculator).courierServices = [];
          }
        })
        .catch(err => console.error(err));
    }

    const courierIdBusiness = (this.$refs
      .calculator as Calculator).getCourierIdBusinessForCourierId(s.courierId);
    const courier_serviceCalc = (this.$refs
      .calculator as Calculator).getCourierService();
    let courierIdBusinessCalc = 0;
    if (courier_serviceCalc) {
      courierIdBusinessCalc = (this.$refs
        .calculator as Calculator).getCourierIdBusinessForCourier(
        courier_serviceCalc.idCourier
      );
    }

    if (s.courierServiceId !== 0) {
      d.courierServiceIdBusiness = s.courierServiceId;
    } else if (!courier_serviceCalc) {
      d.courierServiceIdBusiness = undefined;
    } else if (courierIdBusinessCalc !== courierIdBusiness) {
      return;
    }

    if (courierIdBusiness !== 0) {
      d.courierIdBusiness = courierIdBusiness;
    }
    if (s.courierName !== "") {
      d.courierName = s.courierName;
    }
    if (s.courierShipPackTypeId !== 0) {
      const filteredCourierPackageTypes = this.courierPackageTypes.filter(
        item => item.idMBEBusiness === s.courierShipPackTypeId
      );
      if (filteredCourierPackageTypes.length > 0) {
        d.courierPackTypeIdBusiness =
          filteredCourierPackageTypes[0].idMBEBusiness;
      } else {
        d.courierPackTypeIdBusiness = 0;
      }
    }
    d.sentPaperlessDocument = s.sentPaperlessDocument;

    d.manualCost = null;
    d.manualPrice = null;
    d.mbeProducts = [];

    //mbeServiceIdBusiness optional
    const mbeServiceIdBusiness = s.mbeServiceId;
    if (mbeServiceIdBusiness !== 0) {
      d.mbeServiceIdBusiness = mbeServiceIdBusiness;
    }

    const mbeServiceRequired =
      store.getters["customer/config"].canSelectCourierService &&
      store.getters["customer/config"].canSelectCourier &&
      store.getters["customer/config"].canSelectMBEService;
    if (
      mbeServiceRequired &&
      !d.mbeServiceIdBusiness &&
      !d.courierServiceIdBusiness
    ) {
      // skip if required and no mbeservice or courierService
      return;
    }
    // skip if autopilot enabled and no mbeServiceSelected
    if (this.autopilotEnabled && !d.mbeServiceIdBusiness) return;

    if (!d.mbePackTypeIdBusiness || d.mbePackTypeIdBusiness === 0) return;

    if (s.shipmentPackages.length !== 0) {
      d.packageNumber = s.shipmentPackages.length;
    } else {
      return;
    }
    d.packages = [];
    s.shipmentPackages.forEach(item => {
      const p: PackageDTO = {
        sequence: item.sequence,
        depth: item.depth,
        width: item.width,
        height: item.height,
        customerWeight: item.customerWeight,
        courierWeight: item.customerWeight,
        customerTaxedWeight: 0,
        courierTaxedWeight: 0,
        courierVolume: 0,
        customerVolume: 0,
        itemsNumber: item.itemsNumber,
        specialItemsNumber: item.specialItemsNumber,
        winePackType: item.winePackType
          ? item.winePackType
          : this.isWineShipment
          ? "STANDARD"
          : undefined,
        firstLongerSide: 0,
        secondLongerSide: 0,
        thirdLongerSide: 0,
        girth: 0,
        firstGirth: 0,
        maxSum: 0,
        volume: 0,
        specificPacktype: item.specificPacktype ? item.specificPacktype : null,
        inputMBEDimensionalSurcharge1: false,
        inputMBEDimensionalSurcharge2: false,
        inputMBEDimensionalSurcharge3: false,
        inputCourierDimensionalSurcharge1: false,
        inputCourierDimensionalSurcharge2: false,
        inputCourierDimensionalSurcharge3: false,
        outputMBEDimensionalSurcharge1: false,
        outputMBEDimensionalSurcharge2: false,
        outputMBEDimensionalSurcharge3: false,
        outputCourierDimensionalSurcharge1: false,
        outputCourierDimensionalSurcharge2: false,
        outputCourierDimensionalSurcharge3: false
      } as PackageDTO;

      delete p.customerTaxedWeight;
      delete p.courierTaxedWeight;
      delete p.courierVolume;
      delete p.customerVolume;
      delete p.firstLongerSide;
      delete p.secondLongerSide;
      delete p.thirdLongerSide;
      delete p.girth;
      delete p.firstGirth;
      delete p.maxSum;
      delete p.volume;
      delete p.inputMBEDimensionalSurcharge1;
      delete p.inputMBEDimensionalSurcharge2;
      delete p.inputMBEDimensionalSurcharge3;
      delete p.inputCourierDimensionalSurcharge1;
      delete p.inputCourierDimensionalSurcharge2;
      delete p.inputCourierDimensionalSurcharge3;
      delete p.outputMBEDimensionalSurcharge1;
      delete p.outputMBEDimensionalSurcharge2;
      delete p.outputMBEDimensionalSurcharge3;
      delete p.outputCourierDimensionalSurcharge1;
      delete p.outputCourierDimensionalSurcharge2;
      delete p.outputCourierDimensionalSurcharge3;
      d.packages.push(p);
    });

    d.provinceFrom = s.addressFrom.province;
    d.provinceTo = s.addressTo.province;
    d.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase =
      this.shipAndPackIncluded !== null
        ? this.shipAndPackIncluded
        : s.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase;

    if (s.dismissedExtraServices) {
      d.dismissedExtraServices = s.dismissedExtraServices;
    }

    if (
      this.wineProductUS &&
      (this.shipment.mbeServiceId === 2 || this.shipment.mbeServiceId === 4)
    ) {
      const idSpecialtyBusiness =
        this.dimensionWineProductType === "wine_us" ? 6 : 8;
      if (this.shipment.shipmentId) {
        d.mbeProducts.push(
          ShipmentService.getSpecialty(this.shipment, idSpecialtyBusiness)
        );
      } else {
        d.mbeProducts.push({
          idSpecialtyBusiness,
          wineWarehouseId: this.warehouseSelected.wineWarehouseId,
          wine2PricelistType: this.shipment.mbeServiceId === 2 ? "STD" : "EXP",
          costMBE: 0,
          specialtyName: "",
          idWebService: 0
        });
      }
    }

    if (
      this.dimensionWineProductType === "wine_all" ||
      this.dimensionWineProductType === "spirits_all"
    ) {
      const idSpecialtyBusiness =
        this.dimensionWineProductType === "wine_all" ? 9 : 10;
      if (this.shipment.shipmentId) {
        d.mbeProducts.push(
          ShipmentService.getSpecialty(this.shipment, idSpecialtyBusiness)
        );
      } else {
        d.mbeProducts.push({
          idSpecialtyBusiness,
          costMBE: 0,
          specialtyName: "",
          idWebService: 0
        });
      }
    }

    //#503154990 add shipment date to details
    d.shipmentDate = s.shipmentDate;

    // skip recalcualte if no courier and no mbeservice visible (permission check)
    if (!store.getters["customer/config"].canSelectMBEService) {
      if (!d.mbeServiceIdBusiness && !d.courierIdBusiness) {
        return;
      }
    }

    if (!this.detailsCalled) {
      this.updateAutopilot = false;
    }

    if (
      (this.enabledAutopilotCouriers.length === 0 || this.updateAutopilot) &&
      this.autopilotEnabled &&
      d.mbeServiceIdBusiness &&
      !this.isGel
    ) {
      if (!(!this.detailsCalled && s.status == "FIRST_DRAFT_TO_BE_CLOSED")) {
        autopilotParameter = true;
        delete s["autopilotCourierName"];
        delete s["autopilotCourierIdBusiness"];
      }

      try {
        const res: any = await PriceListService.getAutopilotCouriers(d);
        this.enabledAutopilotCouriers = [];
        const filteredCouriers = res.filter(item => {
          return item.courierName === s.courierName;
        });
        if (filteredCouriers.length === 0) {
          delete d.courierName;
          delete d.courierIdBusiness;
        }

        const couriers = res.map((item: any) => {
          this.enabledAutopilotCouriers.push(item.courierIdBusiness);
          return {
            courierName: item.courierName,
            idCourier: item.courierId,
            idMBEBusiness: item.courierIdBusiness,
            tenantId: getTenantId(),
            supportsCOD: item.supportsCOD
          } as CourierDTO;
        }) as CourierDTO[];
        (this.$refs.calculator as Calculator).setAutopilotCourierToCouriersList(
          couriers
        );
      } catch (err) {
        if (
          this.$store.getters.features.storeAutopilotEnabled &&
          this.$store.state.customer.config.smartChoiceSetting === "AUTOPILOT"
        ) {
          this.$alerts.danger(this.$t(err.response.data.code).toString());
        }
      }
    }

    // remove the autopilotFee extraservice from surcharges list
    d.shipmentSurchargesList = s.extraServices
      .filter(item => {
        if (this.disableCashOnDelivery()) {
          return !(item.mbeBusinessId === 235 || item.mbeBusinessId === 2);
        } else {
          return item.mbeBusinessId !== 235;
        }
      })
      .map(value => {
        return this.processSurcharge(value, d);
      });

    if (
      ((!this.detailsCalled && s.status !== "FIRST_DRAFT_TO_BE_CLOSED") ||
        this.updateAutopilot ||
        s.courierId === this.courierChosenByAutopilot) &&
      this.autopilotEnabled
    ) {
      this.updateAutopilot = false;
      delete d.courierName;
      delete d.courierIdBusiness;
      autopilotParameter = true;
    }
    if (s.customerWeight == 0) return;
    this.blockRecalculatePrice = true;

    if (
      this.shipment.shipmentId &&
      this.shipment.status != "FIRST_DRAFT_TO_BE_CLOSED"
    ) {
      d.skipAutoApply = true;
    }
    if (s.autopilotCourierIdBusiness) {
      d.autopilotCourierIdBusiness = s.autopilotCourierIdBusiness;
    }
    if (s.autopilotCourierName) {
      d.autopilotCourierName = s.autopilotCourierName;
    }

    let selectedMbeServiceId = null;
    const mbeServices = await PriceListService.getMbeServices();
    selectedMbeServiceId = mbeServices.find(
      item => item.idMBEBusiness == d.mbeServiceIdBusiness
    )?.idMBEService;

    this.mbeServiceIdChecked = this.$store.getters.customer.mbeServiceIds.some(
      item => item === selectedMbeServiceId
    );

    d.proformaValue =
      s.proforma && s.proforma.totalValue ? s.proforma.totalValue : undefined;
    d.proformaCurrency =
      s.proforma && s.proforma.currency ? s.proforma.currency : undefined;
    d.proformaIncoterms =
      s.proforma && s.proforma.incoterms ? s.proforma.incoterms : undefined;

    if (
      this.showTaxDutyLogic &&
      s.proforma &&
      Object.keys(s.proforma).length > 0
    ) {
      d.languageCode = s.proforma.language;
      d.proformaDetails = s.proforma.proformaDetails;
    }

    if (this.zonosReseted) {
      d.customDutiesQuoteRequested = false;
      this.zonosReseted = false;
    }

    if (
      this.showTaxDutyLogic &&
      s.proforma &&
      Object.keys(s.proforma).length > 0 &&
      this.taxAndDutyExternalCall
    ) {
      d.customDutiesQuoteRequested = true;
    }

    if (!this.initShipmentDetails && this.showTaxDutyLogic) {
      if (this.hasId && s.landedCosts) {
        d.customDutiesQuoteRequested = true;
      } else {
        d.customDutiesQuoteRequested = false;
      }
      this.initShipmentDetails = true;
    }

    if (this.taxAndDutyExternalCall) {
      d.taxAndDutyExternalCall = true;
    }

    if (this.showTaxDutyLogic && this.shipment.ddpZonos === true) {
      d.ddpZonos = true;
    }

    if (
      this.autopilotEnabled &&
      (this.isPackageDimensionChange || this.courierWeightChange)
    ) {
      autopilotParameter = true;
      delete d.courierName;
      delete d.courierIdBusiness;
      delete d.autopilotCourierIdBusiness;
      delete d.autopilotCourierName;
      delete d.courierPackTypeIdBusiness;
      delete d.courierServiceIdBusiness;
      this.isPackageDimensionChange = false;
      this.courierWeightChange = false;
    }

    d.pickupRequested = s.pickupRequested || false;
    d.pickupDate = s.pickupRequested ? s.pickupDate : undefined;

    await PriceListService.getShipmentPriceDetails(
      d,
      this.isGel ? false : autopilotParameter
    )
      .then(res => {
        const courierServiceToCompare = this.isGel
          ? this.shipment.courierServiceId
          : res[0].courierServiceBusinessId;
        const isShipmentForPickup = !!this.serviceId.find(
          item =>
            item.shipmentType === d.shipType &&
            item.courierServiceBusinessId === courierServiceToCompare
        );
        if (
          !this.$v.shipment.addressTo.$invalid &&
          !this.$v.shipment.mbeService.$invalid &&
          isShipmentForPickup &&
          this.mbeServiceIdChecked
        ) {
          this.pickupOptionVisible = true;
        } else {
          this.pickupOptionVisible = false;
          this.shipment.pickupRequested = false;
        }

        if (res.length > 0) {
          this.prices = res[0];
          this.$store.commit("shipment/setLastDetails", res[0]);
          if (
            this.showTaxDutyLogic &&
            this.prices.landedCosts &&
            Object.keys(this.prices.landedCosts).length > 0
          ) {
            this.$store.commit(
              "shipment/setZonosCalculateResponse",
              cloneDeep(this.prices.landedCosts)
            );
            this.zonosTotalCost = this.prices.landedCosts.totalCosts;
            if (this.taxAndDutyExternalCall) {
              this.zonosCalculateCalled = true;
              this.taxAndDutyExternalCall = false;
            }
          }
          this.shipment.shipNetPrice = this.prices.shipmentNetPrice;
          this.shipment.shipGrossPrice = this.prices.shipmentGrossPrice;
          this.shipment.totalShipNetPrice = this.prices.totalNetPrice;
          this.shipment.totalShipGrossPrice = this.prices.totalGrossPrice;
          this.shipment.vatPercentage = this.prices.vatValueForPrice;
          this.shipment.shipMBEProducts = this.prices.mbeProducts;
          this.shipment.courierShipPackTypeId = this.prices.courierPackTypeIdBusiness;
          this.vatPercentage = this.shipment.vatPercentage;
          this.vatId = this.prices.vatId;
          this.vatCode = this.prices.vatCode;
          this.vatName = this.prices.vatName;
          this.shipAndPackIncluded = this.prices.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase;
          this.shipment.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase = this.prices.useOtherExtraServiceAndShipmentAndExtraServiceValueForBase;
          if (this.prices.productMBECost) {
            this.shipment.costMBE = this.prices.productMBECost;
          }
          if (this.prices.dismissedExtraServices) {
            this.shipment.dismissedExtraServices = this.prices.dismissedExtraServices;
          }
          if (this.prices.publicPrice) {
            this.shipment.publicPrice = this.prices.publicPrice; //UPS public price
          }
          // Adjust package volumetric weight and taxed weight
          for (let i = 0; i < this.prices.packages.length; i++) {
            this.shipment.shipmentPackages[
              i
            ].customerVolumetricWeight = this.prices.packages[i].customerVolume;
            this.shipment.shipmentPackages[
              i
            ].customerTaxedWeight = this.prices.packages[i].customerTaxedWeight;
            // update packages flags

            if (
              this.prices.packages[i].outputMBEDimensionalSurcharge1 !== null
            ) {
              this.shipment.shipmentPackages[
                i
              ].addHandling = this.prices.packages[
                i
              ].outputMBEDimensionalSurcharge1;
            }
            if (
              this.prices.packages[i].outputMBEDimensionalSurcharge2 !== null
            ) {
              this.shipment.shipmentPackages[i].oversize = this.prices.packages[
                i
              ].outputMBEDimensionalSurcharge2;
            }
            if (
              this.prices.packages[i].outputMBEDimensionalSurcharge3 !== null
            ) {
              this.shipment.shipmentPackages[
                i
              ].overweight = this.prices.packages[
                i
              ].outputMBEDimensionalSurcharge3;
            }
          }

          let setAutopilotCourierId = false;
          let setAutopilotCourierName = false;
          if (this.prices.courierBusinessId) {
            this.shipment.courierId = this.prices.courierBusinessId;

            if (!this.autopilotEnabled) {
              this.detailsCalled = true;
            } else if (
              (!this.detailsCalled &&
                s.status !== "FIRST_DRAFT_TO_BE_CLOSED") ||
              autopilotParameter
            ) {
              this.courierChosenByAutopilot = this.prices.courierBusinessId;
              this.shipment.autopilotCourierIdBusiness = this.prices.courierBusinessId;
              setAutopilotCourierId = true;
            } else if (
              !this.detailsCalled &&
              s.status == "FIRST_DRAFT_TO_BE_CLOSED"
            ) {
              this.courierChosenByAutopilot = this.shipment.autopilotCourierIdBusiness;
              setAutopilotCourierId = true;
            }
          }

          if (this.prices.courierName) {
            this.shipment.courierName = this.prices.courierName;
            if (
              this.autopilotEnabled &&
              ((!this.detailsCalled &&
                s.status !== "FIRST_DRAFT_TO_BE_CLOSED") ||
                autopilotParameter)
            ) {
              this.shipment.autopilotCourierName = this.prices.courierName;
              setAutopilotCourierName = true;
            } else if (
              !this.detailsCalled &&
              s.status == "FIRST_DRAFT_TO_BE_CLOSED"
            ) {
              setAutopilotCourierName = true;
            }
          } else {
            if ((this.$refs.calculator as Calculator).courier) {
              const courierName = (this.$refs.calculator as Calculator).courier
                .courierName;
              if (courierName !== this.shipment.courierName) {
                this.shipment.courierName = null;
              }
            } else this.shipment.courierName = null;
          }

          if (
            this.canSelectCourierServices &&
            this.prices.courierServiceBusinessId &&
            this.prices.courierServiceName
          ) {
            this.shipment.courierServiceName = this.prices.courierServiceName;
            this.shipment.courierServiceId = this.prices.courierServiceBusinessId;
          } else {
            this.notVisibleCourierService = this.prices.courierServiceBusinessId;
          }

          if (this.prices.courierServiceBusinessId) {
            this.shipment.courierServiceId = this.prices.courierServiceBusinessId;
          }

          if (
            setAutopilotCourierName ||
            setAutopilotCourierId ||
            !this.$store.getters["customer/config"].canSelectCourier
          ) {
            this.detailsCalled = true;
          }
        }
        // Get payment types for COD extra service (2)
        this.loadCODPayments();
        const courier_services = (this.$refs.calculator as Calculator)
          .courierServices;
        if (
          courier_services &&
          !courier_services.find(
            cs => cs.idBusiness == this.shipment.courierServiceId
          )
        ) {
          (this.$refs.calculator as Calculator).courierServices = [];
        }

        if (
          !this.hasId ||
          this.shipment.status === "FIRST_DRAFT_TO_BE_CLOSED"
        ) {
          //manage auto add service
          this.shipment.extraServices = [];
          this.prices?.surcharges
            .filter(value => value.price || value.cost) // manage autoadded services by backend if any
            .forEach(value => {
              if (this.$refs["extraServices"] !== undefined) {
                const extraservicesElement = this.$refs[
                  "extraServices"
                ] as ExtraServices;
                this.$emit(
                  "add-extraService",
                  extraservicesElement.createExtraServiceFromShipmentExtraServiceDTO(
                    value
                  )
                );
              }
            });
        } else if (
          this.shipment.status === "DRAFT_NO_WAYBILL" ||
          this.shipment.status === "DRAFT_TO_BE_CLOSED"
        ) {
          //manage auto add service
          this.shipment.extraServices = [];
          this.prices?.surcharges
            .filter(value => value.price || value.cost)
            .forEach(value => {
              if (this.$refs["extraServices"] !== undefined) {
                //extraservices by refs
                const extraservicesElement = this.$refs[
                  "extraServices"
                ] as ExtraServices;
                const surchargeItem = {
                  id_mbe_business: value.mbeBusinessId
                };
                this.$emit(
                  "add-extraService",
                  extraservicesElement.createExtraServiceFromShipmentExtraServiceDTO(
                    value
                  )
                );
              }
            });
        }
        this.shipment.extraServices.forEach(extra => {
          for (let i = 0; i < this.prices.surcharges.length; i++) {
            if (
              extra.extraServiceName ===
                this.prices.surcharges[i].extraServiceName &&
              extra.mbeBusinessId === 300
            ) {
              extra.extraServiceValue = this.prices.surcharges[
                i
              ].extraServiceValue;
              extra.calculatedBaseValue = this.prices.surcharges[
                i
              ].calculatedBaseValue;
            }
          }
        });
        this.blockRecalculatePrice = false;
        this.shipment.priceSource = "CUSTOM";
        this.detailsInError = false;
        this.updateAutopilot = false;
      })
      .catch(err => {
        this.notVisibleCourierService = null;
        this.pickupOptionVisible = false;
        if (
          !this.hasId &&
          err.response.data.code !==
            "SAFE_VALUE_4BUSINESS_VALUE_LOWER_THAN_MIN_VALUE"
        ) {
          this.clearNoDetailsData();
        }
        this.blockRecalculatePrice = false;

        if (this.oldPriceSource != "MBE") {
          this.oldPriceSource = this.shipment.priceSource;
        }
        this.shipment.priceSource = "MBE";
        this.detailsInError = true;

        if (err.response.data.code === "SAFE_VALUE_ESSENTIAL_MAX_EXCEEDED") {
          this.$alerts
            .danger(this.$t("max_safe_value_essential_form_error"))
            .then(() => this.recalculatePrice());
        }
      });

    if (this.autopilotEnabled) {
      await this.loadCourierPackageTypes();
      await this.loadCourierServices();
    }
  }
  processSurcharge(value: any, d: ShipmentDetailsInputDTO) {
    const s = { ...value } as ShipmentExtraServiceDTO;
    this.processSafeValues(s, d);

    const dimensionalIds = [27, 28, 29, 30, 31, 220, 221, 222, 223, 224, 225];
    if (dimensionalIds.includes(s.mbeBusinessId) && s.price) {
      (s as any).numberOfPackages = undefined;
    }

    // remove all *read-only* flags: the backend must returns them correctly evaluated
    delete s["applicableOnCost"];
    delete s["applicableOnPrice"];
    delete s["autoAdded"];
    delete s["autoApplyCost"];
    delete s["autoApplyPrice"];
    delete s["overrideVatUser"];
    delete s["overrideVatCustomer"];
    delete s["salePercentage"];
    delete s["saleValue"];
    delete s["saleMinimum"];
    delete s["costValue"];
    delete s["costMinimum"];
    delete s["costPercentage"];
    if (s.vatId == 0) {
      delete s["vatId"];
    }

    // no cost = init as zero for details
    s.cost = s.cost ? s.cost : false;
    if (s.cost === false) {
      s.netCost = s.netCost ? s.netCost : 0;
      s.grossCost = s.grossCost ? s.grossCost : 0;
    }
    return s;
  }

  processSafeValues(s: ShipmentExtraServiceDTO, d: ShipmentDetailsInputDTO) {
    if (s.mbeBusinessId === 1 && s.price) {
      //check if safevalue if selected and
      const existing = ShipmentService.getSpecialty(this.shipment, 1);
      d.mbeProducts.push({
        idSpecialtyBusiness: 1,
        idWebService: existing ? existing.idWebService : 0,
        specialtyName: "MBE SafeValue",
        costMBE: null,
        corporate: existing ? existing.corporate : null
      });
    }

    if (s.mbeBusinessId === 300 && s.price) {
      //check if safevalue if selected and
      const existing = ShipmentService.getSpecialty(this.shipment, 5);
      d.mbeProducts = [
        {
          idSpecialtyBusiness: 5,
          idWebService: existing ? existing.idWebService : 0,
          specialtyName: "MBE SafeValue 4Business",
          costMBE: null,
          corporate: existing ? existing.corporate : null
        }
      ];
    }

    if (s.mbeBusinessId === 332 && s.price) {
      d.mbeProducts = [
        {
          idSpecialtyBusiness: 11,
          idWebService: 0,
          specialtyName: "MBE SafeValue Essential",
          costMBE: null
        }
      ];
    }
  }

  @Debounce(150)
  loadCODPayments() {
    if (this.prices) {
      if (this.prices.courierBusinessId && !this.prices.courierName) {
        store.cache
          .dispatch(
            "cachemod/getPaymentTypes",
            {
              idBusinessCourier: this.prices.courierBusinessId,
              extraServiceId: 2
            },
            {
              timeout: store.state["cachemod"].timeouts.paymentTypes
            }
          )
          .then((res: PaymentTypesDTO[]) => {
            this.paymentTypes = res;
          });
      }
    }
    if (
      this.shipment.courierId !== 0 &&
      this.shipment.courierId !== undefined
    ) {
      store.cache
        .dispatch(
          "cachemod/getPaymentTypes",
          { idBusinessCourier: this.shipment.courierId, extraServiceId: 2 },
          {
            timeout: store.state["cachemod"].timeouts.paymentTypes
          }
        )
        .then((res: PaymentTypesDTO[]) => {
          this.paymentTypes = res;
        });
    }
  }

  /**
   *  clear after details call without response or error
   **/
  clearNoDetailsData() {
    this.prices = null;

    this.shipment.shipNetPrice = 0;
    this.shipment.shipGrossPrice = 0;
    this.shipment.totalShipNetPrice = 0;
    this.shipment.totalShipGrossPrice = 0;
    this.shipment.vatPercentage = 0;

    this.vatPercentage = 0;
    this.vatId = 0;
    this.vatCode = "";
    this.vatName = "";
    this.shipment.costMBE = 0;
    this.shipment.publicPrice = undefined;

    this.shipment.shipmentPackages.forEach(shipmentPackage => {
      shipmentPackage.customerVolumetricWeight = 0;
      shipmentPackage.customerTaxedWeight = 0;
      shipmentPackage.addHandling = false;
      shipmentPackage.oversize = false;
      shipmentPackage.overweight = false;
    });
    this.shipment.extraServices = [];
  }

  get isDeliveryPointServiceSelected() {
    return this.shipment.mbeServiceId === 11;
  }

  @Watch("isDeliveryPointServiceSelected")
  onDeliveryPointSelectedChange(val: boolean) {
    if (!val) {
      this.isDeliveryPointSelected = false;
    }
  }

  @Watch("shipment.addressFrom.macroareaName")
  @Watch("shipment.addressTo.macroareaName")
  onMacroareaChange() {
    let type = "INT";
    if (
      this.shipment.addressFrom.macroareaName === "NATIONAL" &&
      this.shipment.addressTo.macroareaName === "NATIONAL"
    )
      type = "DOM";
    ShipmentService.prototype
      .getKeysSV4B("P", type, this.$store.getters["customer/info"].customerId)
      .then(res => {
        res.configurations.forEach(key => {
          if (key.confKey === "SAFE_VALUE_4B_P_" + type + "_RANGE_1")
            this.sv4bMin = parseFloat(key.confValue);
          if (key.confKey === "SAFE_VALUE_4B_P_" + type + "_RANGE_2")
            this.sv4bMax = parseFloat(key.confValue);
          if (key.confKey === "SAFE_VALUE_4B_P_" + type + "_VALUE")
            this.sv4bValue = parseFloat(key.confValue);
          if (key.confKey === "SAFE_VALUE_4B_P_" + type + "_SHIP_PACK_COVERAGE")
            this.sv4bCoverage = key.confValue === "true";
        });
      });
  }

  @Watch("shipment.extraServices", { deep: true })
  onChangedExtraservice() {
    if (this.sv4bMin === null) {
      this.shipment.extraServices.forEach(e => {
        if (e.mbeBusinessId === 300) {
          this.onMacroareaChange();
        }
      });
    }
  }

  @Watch("$v.shipment.mbeService.$invalid")
  @Watch("mbeServiceSelected")
  @Watch("shipment.courierServiceId")
  checkPickup() {
    if (
      this.$v.shipment.mbeService.$invalid ||
      this.$v.shipment.addressFrom.$invalid ||
      this.$v.shipment.addressTo.$invalid
    ) {
      if (this.pickupOptionVisible) {
        this.shipment.pickupRequested = false;
      }
    }

    if (
      this.isGel &&
      this.mbeserviceSelected &&
      this.mbeserviceSelected.idMBEService
    ) {
      const courierVisibility = this.$store.getters[
        "customer/courierVisibilityConfig"
      ].find(
        (el: any) =>
          el.mbeServiceId === this.mbeserviceSelected.idMBEService &&
          el.courierServiceIdBusiness === this.shipment.courierServiceId
      );

      if (
        !this.$v.shipment.addressFrom.$invalid &&
        !this.$v.shipment.addressTo.$invalid &&
        !this.$v.shipment.mbeService.$invalid &&
        courierVisibility &&
        courierVisibility.canRequestPickup
      ) {
        this.pickupOptionVisible = true;
      }
    }
  }

  @Watch("initResetZonos")
  onInitZonosChange() {
    this.resetZonosData("initZonosChange");
  }

  @Watch("initZonosCourierServiceList")
  onInitZonosCourierServiceList() {
    this.resetZonosData("initZonosCourierServiceList");
  }
  loadedDocs: any[] = [];
  confirmAttachments(documents: any) {
    this.loadedDocs = documents;
    this.$emit("confirmAttachments", documents);
  }
  toggleAttachements(modalAttachmentsEnabled: boolean) {
    this.modalAttachmentsVisible = modalAttachmentsEnabled;
    if (!modalAttachmentsEnabled) {
      this.loadedDocs = [];
      this.$emit("confirmAttachments", []);
    }
  }

  resetZonosData(calledMethod = "", afterInit = false) {
    if (
      this.showTaxDutyLogic &&
      this.initResetZonos &&
      this.initZonosCourierServiceList
    ) {
      if (this.isZonosCourierServiceSupported) {
        this.disableDDPOptions =
          this.shipment.proforma.incoterms === "DDP" && !this.edition;
      } else {
        this.disableDDPOptions = false;
        this.disableZonosDDP = false;
      }
      if (afterInit && this.initResetZonos) {
        this.shipment.requestedChargeCustomDuties = false;
        this.shipment.customsDutiesToCustomer = false;
        this.shipment.ddpZonos = false;
        this.shipment.requestedChargeCustomDutiesDefinedByMolUser = false;
        this.hideDDPValues = false;
        this.zonosTotalCost = "";
        this.zonosReseted = true;
        this.$store.commit("shipment/setZonosCalculateResponse", null);
      }
    }
  }

  syncShipmentType(value: any) {
    if (this.autopilotEnabled) {
      this.shipment.mbeServiceId = null;
      this.shipment.mbeService = null;
    }
    this.shipment.shipmentType = value;
    this.prefillAddressesAfterShipmentTypeChanged();
    this.loadMBEServices()
      .then(() => this.loadCouriers())
      .then(() => this.loadCourierPackageTypes())
      .then(() => this.loadCourierServices())
      .then(() => this.recalculatePrice());
  }

  syncAddressFromSubcountry(value: any) {
    this.shipAndPackIncluded = null;
    if (this.shipment && this.shipment.extraServices) {
      for (const element of this.shipment.extraServices) {
        if (element.mbeBusinessId === 300 && !this.edition) {
          element.extraServiceValue = null;
        }
      }
    }
    this.shipment.addressFrom.cee = value.cee;
    this.checkShipmentType();
    this.loadCouriers()
      .then(() => this.loadCourierPackageTypes())
      .then(() => {
        this.loadCourierServices();
      })
      .then(() => this.recalculatePrice());
  }

  syncAddressFromCity() {
    this.recalculatePrice();
  }

  syncAddressToCity() {
    this.updateAutopilot = true;
    this.recalculatePrice();
  }

  async syncAddressToSubcountry(value: any) {
    this.updateAutopilot = true;
    if (value !== null) {
      this.shipment.addressTo.cee = value.cee;
    }
    this.checkShipmentType();
    if (this.cancelSource !== undefined) {
      this.cancelSource.cancel("Cancelling on subCountry change requests");
    }
    this.cancelSource = this.cancelToken.source();
    this.shipAndPackIncluded = null;
    if (this.shipment && this.shipment.extraServices) {
      for (const element of this.shipment.extraServices) {
        if (element.mbeBusinessId === 300 && !this.edition) {
          element.extraServiceValue = null;
        }
      }
    }

    try {
      await this.loadMBEServices(this.cancelSource);
      await this.loadCouriers(this.cancelSource);
      await this.loadCourierPackageTypes(this.cancelSource);
      await this.loadCourierServices(this.cancelSource);
      await this.recalculatePrice();

      this.cancelSource = undefined;
      if (
        !this.isDeliveryPointSelected &&
        this.isDeliveryPointServiceSelected &&
        !this.isInboundShipment
      ) {
        this.isDeliveryPointSelected = true;
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        this.cancelSource = undefined;
      }
    }
  }

  syncAddressCountry(field: string) {
    if (this.autopilotEnabled) {
      this.shipment.mbeServiceId = null;
      this.shipment.mbeService = null;
    }

    if (field === "addressToCountry") {
      this.updateAutopilot = true;
    }

    this.checkShipmentType();
    if (!this.isInboundShipment) {
      this.isDeliveryPointSelected = false;
      const shipment = cloneDeep({
        ...this.shipment,
        mbeServiceId: 0,
        mbeService: "",
        courierId: 0,
        courierName: "",
        addressAccessPoint: undefined,
        addressTo: {
          ...this.shipment.addressTo,
          subcountry: "",
          subcountryId: 0
        }
      });

      this.$nextTick(() => {
        this.$emit("updateShipment", shipment);
      });
    }

    this.loadCouriers(true)
      .then(() => this.loadCourierPackageTypes())
      .then(() => {
        this.loadCourierServices();
      })
      .then(() => this.recalculatePrice())
      .then(() => {
        (this.$refs.calculator as Calculator).courierModified(
          (this.$refs.calculator as Calculator).courier,
          false
        );
        if (this.isDeliveryPointSelected) {
          this.$emit("fixPackagesForDeliveryPoint");
        }
      });
  }

  private isMbeDeliveryPoint(id: number | undefined): boolean {
    return id === 11 || id === 12;
  }

  private syncDeliveryPointSelection(value: any): void {
    const valueIsDeliveryPoint =
      value &&
      Object.keys(value).length > 0 &&
      this.isMbeDeliveryPoint(value.idMBEBusiness);

    const shipmentIsDeliveryPoint = this.isMbeDeliveryPoint(
      this.shipment.mbeServiceId
    );

    if (valueIsDeliveryPoint || shipmentIsDeliveryPoint) {
      this.isDeliveryPointSelected = true;
      return;
    }

    const valueIsNotDeliveryPoint =
      value && !this.isMbeDeliveryPoint(value.idMBEBusiness);
    const shipmentIsNotDeliveryPoint = !this.isMbeDeliveryPoint(
      this.shipment.mbeServiceId
    );

    if (valueIsNotDeliveryPoint || shipmentIsNotDeliveryPoint) {
      this.isDeliveryPointSelected = false;
      if (this.hasAccessPointData) {
        this.shipment.addressTo = new AddressShipmentDTO();
      }
      this.shipment.addressAccessPoint = undefined;
    }
  }

  private deleteCourierData(): void {
    this.shipment.courierId = undefined;
    this.shipment.courierName = undefined;
    this.shipment.courierServiceId = undefined;
    this.shipment.courierServiceName = undefined;
  }

  async syncMbeService(value: any): Promise<void> {
    const serviceChanged =
      value !== undefined &&
      value.idMBEBusiness !== this.shipment.mbeServiceId &&
      this.initResetZonos;

    if (serviceChanged) {
      this.resetZonosData("mbeService", true);
    }

    this.updateAutopilot = true;

    this.syncDeliveryPointSelection(value);

    await this.loadCouriers();

    const calculator = this.$refs.calculator as Calculator;
    const hasSameCourier = calculator.couriers.find(
      c =>
        (c.idMBEBusiness === this.shipment.courierId && c.idCourier) ||
        this.isDraft < 2
    );

    if (!hasSameCourier || !this.canSelectCourier) {
      this.deleteCourierData();
    }

    this.isDraft++;

    if (this.canSelectCourier) {
      this.loadCourierPackageTypes();
    }

    await this.loadCourierServices();
    await this.recalculatePrice();
    await calculator.courierModified(calculator.courier, false);

    if (this.isDeliveryPointSelected) {
      this.$emit("fixPackagesForDeliveryPoint");
    }
  }

  syncPackageType() {
    this.updateAutopilot = true;
    if (this.autopilotEnabled) {
      this.oldMbeServiceId = this.shipment.mbeServiceId;
      this.oldMbeService = this.shipment.mbeService;
      this.shipment.mbeServiceId = null;
      this.shipment.mbeService = null;
    }

    this.loadCouriers().then(() => {
      this.loadCourierPackageTypes();
    });
  }

  private updatePaperlessFlags(isCourierPaperless: boolean) {
    this.disableAttachmentPaperlessDocumentFlag = !isCourierPaperless;
    !isCourierPaperless && (this.shipment.sentPaperlessDocument = false);
  }

  async syncCourier(value: any) {
    if (this.canSelectCourier) {
      if (
        (this.shipment.addressFrom.macroareaName !== "WORLDWIDE" &&
          this.shipment.addressTo.macroareaName !== "WORLDWIDE" &&
          !this.shipmentWithCee() &&
          !this.isNorthIrelandEu()) ||
        this.isSameSubcountry()
      ) {
        this.disableAttachmentPaperlessDocumentFlag = true;
      } else {
        ShipmentService.prototype
          .verifyPaperlessUsage(this.shipment.courierId)
          .then(paperlessEnabled => {
            this.updatePaperlessFlags(paperlessEnabled);
          })
          .catch(error => {
            console.error(error);
            this.disableAttachmentPaperlessDocumentFlag = true;
          });
      }
      if (
        value !== undefined &&
        value !== this.shipment.courierId &&
        this.initResetZonos
      ) {
        this.resetZonosData("courier", true);
      }
    } else {
      this.disableAttachmentPaperlessDocumentFlag = !this.showProformaAccordion;
    }

    if (
      this.isWineShipment &&
      this.wineProductUS &&
      this.canSelectCourier &&
      this.wineCourierService &&
      Object.entries(this.wineCourierService).length > 0
    ) {
      this.recalculatePrice();
      return;
    }

    if (this.canSelectCourier) {
      await this.loadCourierPackageTypes();
    }
    await this.loadCourierServices();
    if (this.shipment.mbeServiceId === 0 && this.shipment.mbeService === "") {
      this.tryToSelectMBEService().then(() => this.recalculatePrice());
    } else {
      this.recalculatePrice();
    }
  }

  syncCourierService() {
    if (this.initResetZonos) {
      this.resetZonosData("courierService", true);
    }

    if (this.shipment.mbeServiceId === 0 && this.shipment.mbeService === "") {
      this.tryToSelectMBEService().then(() => {
        if (this.isDeliveryPointServiceSelected) {
          this.isDeliveryPointSelected = true;
        }
        this.recalculatePrice();
      });
    } else {
      this.recalculatePrice();
    }
  }

  syncCourierAndCourierService() {
    if (this.shipment.mbeServiceId === 0 && this.shipment.mbeService === "") {
      this.tryToSelectMBEService().then(() => this.recalculatePrice());
    } else {
      this.recalculatePrice();
    }
  }

  async syncShipmentOptions(field: string, value: any) {
    if (!this.edition) return;

    switch (field) {
      case "shipmentType":
        this.syncShipmentType(value);
        break;
      case "addressFromSubcountry":
        this.syncAddressFromSubcountry(value);
        break;
      case "addressFromCity":
        this.syncAddressFromCity();
        break;
      case "addressToCity":
        this.syncAddressToCity();
        break;
      case "addressToSubcountry":
        this.syncAddressToSubcountry(value);
        break;
      case "addressFromCountry":
      case "addressToCountry":
        this.syncAddressCountry(field);
        break;
      case "mbeService":
        this.syncMbeService(value);
        break;
      case "packageType":
        this.syncPackageType();
        break;
      case "courier":
        this.syncCourier(value);
        break;
      case "courierService":
        this.syncCourierService();
        break;
      case "courierAndCourierService":
        this.syncCourierAndCourierService();
        break;
    }
  }

  get zonosInvalidItems() {
    return this.$store.getters[
      "shipment/zonosInvalidItems"
    ] as ZonosCalculateResponseItemDTO[];
  }

  async savedProforma() {
    this.isProformaDone = true;
    if (this.showTaxDutyLogic) {
      if (
        this.shipment.customsDutiesToCustomer !==
          this.oldShipmentData.customsDutiesToCustomer ||
        this.shipment.requestedChargeCustomDuties !==
          this.oldShipmentData.requestedChargeCustomDuties ||
        this.shipment.ddpZonos !== this.oldShipmentData.ddpZonos
      ) {
        if (this.zonosInvalidItems && this.zonosInvalidItems.length > 0) {
          const proformaHasInvalidItems = this.shipment.proforma.proformaDetails.some(
            (el: ProformaDetailsDTO) =>
              this.zonosInvalidItems.some(
                (item: ZonosCalculateResponseItemDTO) => {
                  return item.position === el.position && item.restricted;
                }
              )
          );

          if (!proformaHasInvalidItems) {
            this.$store.commit("shipment/setZonosInvalidItems", []);
            this.disableZonosDDP = false;
            // this.hideDDPValues = true;
          }

          this.disableDDPOptions = false;
          this.zonosTotalCost = "";
          if (this.shipment.taxAndDutyId) {
            this.shipment.taxAndDutyId = undefined;
          }
          this.resetTaxDutyData();
          await this.recalculatePrice();
        } else {
          this.disableZonosDDP = false;
        }
      }

      if (this.isProformaIncotermDAP) {
        this.shipment.requestedChargeCustomDuties = false;
        this.shipment.customsDutiesToCustomer = false;
        this.shipment.ddpZonos = false;
      }
      const oldProformaDetails =
        this.oldShipmentData &&
        this.oldShipmentData.proforma &&
        this.oldShipmentData.proforma.proformaDetails
          ? cloneDeep(this.oldShipmentData.proforma.proformaDetails)
          : [];
      const newProformaDetails =
        this.shipment.proforma && this.shipment.proforma.proformaDetails
          ? cloneDeep(this.shipment.proforma.proformaDetails)
          : [];
      const oldIncoterm =
        this.oldShipmentData &&
        this.oldShipmentData.proforma &&
        this.oldShipmentData.proforma.incoterms
          ? this.oldShipmentData.proforma.incoterms
          : "";
      const newIncoterm =
        this.shipment.proforma && this.shipment.proforma.incoterms
          ? this.shipment.proforma.incoterms
          : "";
      const diffProformaDetails = !equal(
        oldProformaDetails,
        newProformaDetails
      );
      const oldLanguage = this.oldShipmentData.proforma.language;
      const newLanguage = this.shipment.proforma.language;

      if (
        diffProformaDetails ||
        oldIncoterm !== newIncoterm ||
        oldLanguage !== newLanguage
      ) {
        if (
          !this.isZonosCourierServiceSupported &&
          this.isProformaDDP &&
          this.shipment.customerWeight > 0
        ) {
          this.hideDDPValues = false;
          this.disableDDPOptions = false;
        }

        this.zonosTotalCost = "";
        this.resetTaxDutyData();
        this.disableZonosDDP = false;
        await this.recalculatePrice();
        if (!this.shipment.customerWeight) {
          this.$alerts.danger(
            String(i18n.t("TAX-DUTY-CALCULATION-MISSING-COURIER-WEIGHT"))
          );
        }
      }
    }

    if (this.shipment.sentPaperlessDocument && this.shipment.courierId !== 4) {
      let isAlreadySelected = false;
      const paperlessDocuments = (this.$refs
        .paperless_table as PaperlessManagementTable).paperlessDocuments;

      if (
        this.shipment.paperlessDocumentIds &&
        this.shipment.paperlessDocumentIds.length > 0 &&
        paperlessDocuments &&
        paperlessDocuments.length > 0
      ) {
        this.shipment.paperlessDocumentIds.forEach(paperless => {
          const doc = paperlessDocuments.find((d: any) => d.id == paperless);
          if (doc) {
            if (
              (this.shipment.proforma as any).invoiceType == "PROFORMA" &&
              doc.id !== this.proformaIdAdded
            ) {
              isAlreadySelected =
                isAlreadySelected ||
                doc.courierDocumentTypeCode.includes("Proforma");
            } else if (
              (this.shipment.proforma as any).invoiceType !== "PROFORMA" &&
              doc.id !== this.proformaIdAdded
            ) {
              isAlreadySelected =
                isAlreadySelected ||
                doc.courierDocumentTypeCode.includes("Commercial Invoice");
            }
          }
        });
      }
      if (!isAlreadySelected) {
        this.proformaService = new ProformaService();
        this.proformaService
          .previewProforma(
            this.shipment,
            this.$store.getters["customer/info"].tenantId,
            this.$store.getters["customer/info"].multiStoreId
          )
          .then((res: any) => {
            this.processFile(res);
          });
      }
    }
  }

  proformaIdAdded = 0;
  proformaService: ProformaService;

  async processFile(document: any) {
    const documentTypes = await this.fetchDocTypes();
    let documentType;
    if (
      (this.shipment.proforma as any).invoiceType.toLowerCase() == "proforma"
    ) {
      documentType = documentTypes.find((d: any) =>
        d.description.toLowerCase().includes("proforma")
      );
    } else {
      documentType = documentTypes.find((d: any) =>
        d.description.toLowerCase().includes("commercial invoice")
      );
    }
    const documentTypeId = documentType ? documentType.id : "1";

    const documentBlob = convertBase64toBlob(document, "application/pdf");

    if (this.proformaIdAdded !== 0) {
      ShipmentService.prototype.deletePaperlessDocumentByIds([
        this.proformaIdAdded
      ]);
    }

    this.uploadPaperlessDocument(documentBlob, documentTypeId)
      .then(res => {
        this.proformaIdAdded = res[0].id;

        const recentlyUploadedPaperlessDocumentIds = (this.$refs
          .paperless_table as PaperlessManagementTable)
          .recentlyUploadedPaperlessDocumentIds;
        (this.$refs
          .paperless_table as PaperlessManagementTable).recentlyUploadedPaperlessDocumentIds = [
          ...recentlyUploadedPaperlessDocumentIds,
          this.proformaIdAdded
        ];

        this.$notify.success(String(i18n.t("document_added_successfully")));
        this.searchDocuments(res[0].id);
      })
      .catch(err => {
        return alertDangerReason(err, this);
      });
  }

  async fetchDocTypes() {
    const res = await ShipmentService.prototype.getAvailablePaperlessDocumentTypes();
    if (this.shipment.courierId) {
      return res.filter((item: any) => {
        return Object.keys(item.allowedCouriers).includes(
          this.shipment.courierId.toString()
        );
      });
    } else {
      return res;
    }
  }

  dualUseIdAdded: number | null = null;
  generatingDualUse = false;

  get showGenerateDualUse() {
    return canGenerateDualUse(this.shipment, this.$store.state.currentLogin);
  }

  async generateAndAttachDualUse() {
    this.generatingDualUse = true;
    try {
      const documentType = dualUseDocumentType(await this.fetchDocTypes());
      if (!documentType) {
        this.$alerts.danger(String(i18n.t("INVALID_COURIER_DOCUMENT_TYPE")));
        return;
      }
      const info = this.$store.getters["customer/info"];
      const pdf = await new ProformaService().generateDualUseDocument(
        this.shipment,
        info.tenantId,
        info.multiStoreId,
        getLanguageFromTenant(info.tenantId)
      );
      const res = await this.uploadPaperlessDocument(
        convertBase64toBlob(pdf, "application/pdf"),
        String(documentType.id),
        dualUseFilename(new Date())
      );
      const replacement = replaceDualUse(
        this.dualUseIdAdded,
        res[0].id,
        this.shipment.paperlessDocumentIds
      );
      this.shipment.paperlessDocumentIds = replacement.paperlessDocumentIds;
      this.dualUseIdAdded = replacement.attachedId;
      if (replacement.deleteId !== null) {
        await ShipmentService.prototype
          .deletePaperlessDocumentByIds([replacement.deleteId])
          .catch(err => console.error(err));
      }
      this.$notify.success(String(i18n.t("document_added_successfully")));
      this.searchDocuments(replacement.attachedId);
    } catch (err) {
      alertDangerReason(err, this).catch(() => undefined);
    } finally {
      this.generatingDualUse = false;
    }
  }

  async uploadPaperlessDocument(
    file: any,
    documentTypeId: string,
    filename = (
      (this.shipment.proforma as any).invoiceType +
      " " +
      new Date()
    ).split(" GMT")[0] + ".pdf"
  ) {
    const formData: any = new FormData();

    formData.append("paperlessDocuments[0].file", file, filename);
    formData.append(
      "paperlessDocuments[0].paperlessMbeDocumentTypeId",
      documentTypeId
    );
    formData.append(
      "customerId",
      this.$store.getters["customer/info"].customerId
    );
    formData.append("molUsername", this.$store.getters.user.username);
    formData.append("fromMol", true);
    formData.append("paperlessDocuments[0].notes", "");

    return ShipmentService.prototype.uploadPaperlessDocument(formData);
  }

  @Watch("shipment.mbeServiceId")
  onMbeServiceChange(id: number) {
    this.syncShipmentOptions("mbeService", undefined);
  }

  @Debounce(500)
  @Watch("shipment.addressTo", { deep: true })
  onAddressToChange(address: any, oldAddress: any) {
    if (address === oldAddress || !this.initResetZonos) return;
    this.resetZonosData("shipment.adressTo", true);
  }

  @Watch("shipment.addressFrom.macroareaName")
  @Watch("shipment.addressTo.macroareaName")
  async checkShipmentType() {
    let change: ShipType = null;
    const macroAreaFrom = this.shipment?.addressFrom?.macroareaName;
    const macroAreaTo = this.shipment?.addressTo?.macroareaName;
    if (macroAreaFrom === "NATIONAL" && macroAreaTo === "NATIONAL") {
      change = "DOMESTIC";
    }

    if (macroAreaFrom === "NATIONAL" && macroAreaTo !== "NATIONAL") {
      change = "EXPORT";
    }

    if (macroAreaFrom !== "NATIONAL" && macroAreaTo === "NATIONAL") {
      change = "IMPORT";
    }

    if (macroAreaFrom !== "NATIONAL" && macroAreaTo !== "NATIONAL") {
      change = "EXPORT";
    }
    if (macroAreaFrom === "NATIONAL" && macroAreaTo === "") {
      change = "DOMESTIC";
    }

    if (this.isWineShipment && this.wineProductUS) {
      change = "INTRAWW";
    }

    if (change && change !== this.shipment.shipmentType) {
      if (this.autopilotEnabled) {
        this.shipment.mbeServiceId = null;
        this.shipment.mbeService = null;
      }
      this.shipment.shipmentType = change;

      await this.loadMBEServices();
      await this.loadCouriers();
      await this.loadCourierPackageTypes();
      await this.loadCourierServices();
      await this.recalculatePrice();
    }
  }

  get canSelectCourier() {
    return store.getters["customer/config"].canSelectCourier;
  }
  get showAttachment() {
    if (this.disableAttachments) return false;
    if (!this.detailsCalled && !this.shipment.shipmentId) {
      return false;
    }
    return !(
      this.showPaperlessCheckbox &&
      !this.disableAttachmentPaperlessDocumentFlag &&
      !this.hidePaperless
    );
  }
  get showPaperlessCheckbox() {
    if (store.getters.features.storePaperlessEnabled && this.detailsCalled) {
      return true;
    }
    return (
      store.getters.features.storePaperlessEnabled &&
      this.$route.name === "EditShipment"
    );
  }
  get disableAttachments() {
    return (
      (this.shipment.addressFrom.macroareaName !== "WORLDWIDE" &&
        this.shipment.addressTo.macroareaName !== "WORLDWIDE" &&
        !this.shipmentWithCee() &&
        !this.isNorthIrelandEu()) ||
      this.isSameSubcountry()
    );
  }

  get canSelectCourierServices() {
    return this.$store.getters["customer/config"].canSelectCourierService;
  }

  @Watch("shipment.addressFrom.subcountryId")
  onSubCChange() {
    if (this.wineProductUS) {
      return;
    }

    this.loadCouriers();
  }

  @Watch("shipment.shipmentPackages", { deep: true })
  onPackagesChange(list: ShipmentPackageDTO[]) {
    if (!this.isDeliveryPointSelected) return;
    const shipmentPackage: ShipmentPackageDTO = list[0];
    const dimensions = [
      shipmentPackage.width,
      shipmentPackage.height,
      shipmentPackage.depth
    ].sort((a, b) => b - a);
    const longestSide = dimensions[0];
    const invalidSize = dimensions[0] * 2 + dimensions[1] * 2 > 300;
    if (
      shipmentPackage.courierWeight >= 20 ||
      longestSide > 97 ||
      invalidSize
    ) {
      this.$emit("invalidDimensionsForDeliveryPoint", true);
    } else {
      this.$emit("invalidDimensionsForDeliveryPoint", false);
    }
  }

  @Watch("shipment.shipmentType")
  onShipmentTypeChange() {
    this.isPhoneRequired =
      (this.shipment.shipmentType === "EXPORT" &&
        (this.shipment.courierId === 1 || this.shipment.courierId === 3)) ||
      isSpain();
  }

  @Watch("shipment.courierId")
  onCourierChange() {
    if (this.isCourierTNT) {
      this.shipment.customsDutiesToCustomer = false;
    }

    this.onShipmentTypeChange();
    this.loadCODPayments();
    if (this.initDone) {
      this.disableCanChargeCustomDutiesDefinedByMolUser();
    }
    if (
      this.shipment.courierId == 4 &&
      this.shipment.proforma &&
      (!this.shipment.proforma.proformaDetails ||
        this.shipment.proforma.proformaDetails.length == 0)
    ) {
      this.proformaTotalValue = 0;
    }

    if (
      this.canSelectCourier ||
      (this.shipment.courierId && this.shipment.courierId != 0)
    ) {
      if (
        (this.shipment.addressFrom.macroareaName !== "WORLDWIDE" &&
          this.shipment.addressTo.macroareaName !== "WORLDWIDE" &&
          !this.shipmentWithCee() &&
          !this.isNorthIrelandEu()) ||
        this.isSameSubcountry()
      ) {
        this.disableAttachmentPaperlessDocumentFlag = true;
      } else {
        ShipmentService.prototype
          .verifyPaperlessUsage(this.shipment.courierId)
          .then(paperlessEnabled => {
            this.updatePaperlessFlags(paperlessEnabled);
          })
          .catch(error => {
            console.error(error);
            this.disableAttachmentPaperlessDocumentFlag = true;
          });
      }
    }
  }

  spainCanaryShipment() {
    return (
      (this.shipment.addressTo.countryId == "ES" &&
        this.shipment.addressFrom.countryId == "IC") ||
      (this.shipment.addressTo.countryId == "IC" &&
        this.shipment.addressFrom.countryId == "ES")
    );
  }

  isCanaryShipment() {
    return (
      this.shipment.addressFrom.countryId == "IC" ||
      this.shipment.addressTo.countryId == "IC"
    );
  }

  shipmentWithCee() {
    return !this.shipment.addressFrom.cee || !this.shipment.addressTo.cee;
  }

  isSameSubcountry() {
    return (
      this.shipment.addressFrom.subcountryId ==
      this.shipment.addressTo.subcountryId
    );
  }

  async showAccessPointModal() {
    if (
      this.isDeliveryPointSelected &&
      (!this.canSelectCourier || !this.canSelectCourierServices)
    ) {
      this.shipment.courierId = 1;
      this.shipment.courierName = "UPS";
    }
    this.showAccessPointsModal = true;
  }

  resetCourierData() {
    this.$emit("resetCourier");
  }

  resetCourierServiceData() {
    this.$emit("resetCourierService");
  }

  async loadCouriers(
    cancelSource: any = undefined,
    force = false
  ): Promise<any> {
    if (this.$refs.calculator !== undefined) {
      if (!this.canSelectCourier && !force && !this.isGel) {
        this.resetCourierData();
      }

      await this.$nextTick();
      return (this.$refs.calculator as Calculator).loadCouriers(
        cancelSource,
        force
      );
    } else {
      return Promise.resolve(null);
    }
  }

  async loadCourierPackageTypes(cancelSource: any = undefined) {
    if (this.shipment.courierId === 0 || this.wineProductUS) {
      return Promise.resolve(null);
    }

    const calculator = this.$refs.calculator as Calculator;
    if (!calculator) {
      return;
    }

    const courier = (this.$refs.calculator as Calculator).courier;
    if (courier === null) {
      return Promise.resolve(null);
    }

    const courierDatabaseId = courier.idCourier
      ? courier.idCourier
      : courier.idMBEBusiness;

    const packageType = (this.$refs.calculator as Calculator).mbePackage;
    if (packageType === null) {
      return Promise.resolve(null);
    }

    const pack = this.packTypes.find(
      p => p.idMBEBusiness == packageType.packtypeBusinessId
    );
    if (!pack) {
      return Promise.resolve(null);
    }

    const packtypeBusinessId = pack.idMBEPackType;
    return await this.$store.cache
      .dispatch("cachemod/getCourierPackageTypes", {
        idCourier: courierDatabaseId,
        subcountryFromId: this.shipment.addressFrom.subcountryId,
        subcountryToId: this.shipment.addressTo.subcountryId,
        shipmentType: this.shipment.shipmentType,
        MBEServiceId: this.shipment.mbeServiceId,
        idMBEBusiness: 0,
        idMBEPackType: packtypeBusinessId
      })
      .then((res: CourierPackageTypeDTO[]) => {
        this.courierPackageTypes = res;

        // Try to assign shipment package type based on mbe pack type
        const filteredCourierPackTypes = this.courierPackageTypes.filter(
          item =>
            item.idCourier === courierDatabaseId &&
            item.idMBEPackType === packtypeBusinessId
        );
        if (filteredCourierPackTypes.length === 1) {
          this.shipment.courierShipPackType =
            filteredCourierPackTypes[0].packTypeDescription;
          this.shipment.courierShipPackTypeId =
            filteredCourierPackTypes[0].idMBEBusiness;
        }
        if (res.length == 0) {
          this.resetCourierData();
          this.resetCourierServiceData();
          (this.$refs.calculator as Calculator).couriers = [];
          (this.$refs.calculator as Calculator).courierServices = [];
        }

        this.loadCourierServices(
          undefined,
          undefined,
          JSON.parse(JSON.stringify(this.courierPackageTypes))
        );
      });
  }

  loadCourierServices(
    cancelSource: any = undefined,
    force = false,
    packtypes?
  ): Promise<any> {
    if (this.$refs.calculator !== undefined) {
      return (this.$refs.calculator as Calculator).loadCourierServices(
        cancelSource,
        force,
        packtypes
      );
    } else {
      return Promise.resolve(null);
    }
  }

  loadMBEServices(cancelSource: any = undefined): Promise<any> {
    if (this.$refs.mbeService !== undefined) {
      return (this.$refs.mbeService as MBEService).loadServices(cancelSource);
    } else {
      return Promise.resolve(null);
    }
  }

  tryToSelectMBEService() {
    if (this.$refs.mbeService !== undefined) {
      return (this.$refs.mbeService as MBEService).trySelectingService();
    } else {
      return Promise.resolve();
    }
  }

  setAddressForAsCustomer() {
    const customerBusinessName = this.$store.getters["customer/info"]
      .businessName;
    const customerContact = this.$store.getters["customer/info"].address;
    if (customerContact.addresses.length >= 1) {
      this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
        customerContact,
        customerContact.addresses[0],
        "",
        "NATIONAL",
        customerBusinessName
      );
    }
    this.calculateMacroAreaForAddress("addressFor");
  }

  selectDepartment(department: DepartmentDTO) {
    if (
      department &&
      (department.departmentId === undefined || department.departmentId <= 0)
    ) {
      this.shipment.customerDepartmentId = 0;
      this.shipment.customerDepartment = "";
      this.departmentSelected = department.departmentBusinessName;

      this.setAddressForAsCustomer();
      setTimeout(() => {
        if (this.$refs.addressFrom !== undefined) {
          (this.$refs.addressFrom as Address).forceReload();
        }
      }, 100);
      setTimeout(() => {
        if (this.$refs.addressTo !== undefined) {
          (this.$refs.addressTo as Address).forceReload();
        }
      }, 100);
      setTimeout(() => {
        if (this.$refs.addressFor !== undefined) {
          (this.$refs.addressFor as Address).forceReload();
        }
      }, 100);
      if (this.isInboundShipment) {
        this.$emit("changeAddressToFromUser");
      }
    } else {
      this.departmentSelected = "";
      const isDepartmentMandatory =
        store.getters["customer/config"].isDepartmentMandatory;
      if (this.isInboundShipment && isDepartmentMandatory) {
        this.$emit("removeSelectedReceiverButton");
      }
      if (department) {
        this.departmentSelected = department.departmentBusinessName;
        this.shipment.customerDepartmentId = department.departmentId || 0;
        this.shipment.customerDepartment = department.departmentBusinessName;
      }
      const departments = this.$store.getters["customer/departments"];
      const filteredDepartments = departments.filter((item: DepartmentDTO) => {
        return item.departmentId === this.shipment.customerDepartmentId;
      });
      if (filteredDepartments.length > 0) {
        this.shipment.customerDepartment =
          filteredDepartments[0].departmentBusinessName;
        if (
          typeof filteredDepartments[0].address !== "undefined" &&
          typeof filteredDepartments[0].address.addresses !== "undefined" &&
          filteredDepartments[0].address.addresses.length > 0
        ) {
          if (this.isInboundShipment) {
            setTimeout(() => {
              this.shipment.addressTo = AddressShipmentDTO.fromContactDTO(
                filteredDepartments[0].address,
                filteredDepartments[0].address.addresses[0],
                this.$store.getters["customer/info"].vatNumber,
                "NATIONAL",
                filteredDepartments[0].departmentBusinessName,
                this.$store.getters["customer/info"].eori,
                this.$store.getters["customer/info"].fiscalCode
              );
              this.calculateMacroAreaForAddress("addressTo");
            }, 100);
            setTimeout(() => {
              if (this.$refs.addressStore !== undefined) {
                (this.$refs.addressStore as Address).forceReload();
              }
            }, 100);
            setTimeout(() => {
              if (this.$refs.addressTo !== undefined) {
                (this.$refs.addressTo as Address).forceReload();
              }
            }, 100);
            setTimeout(() => {
              if (this.$refs.addressFor !== undefined) {
                (this.$refs.addressFor as Address).forceReload();
              }
            }, 100);
          } else {
            this.shipment.addressFor = AddressShipmentDTO.fromContactDTO(
              filteredDepartments[0].address,
              filteredDepartments[0].address.addresses[0],
              this.$store.getters["customer/info"].vatNumber,
              "NATIONAL",
              filteredDepartments[0].departmentBusinessName,
              this.$store.getters["customer/info"].eori,
              this.$store.getters["customer/info"].fiscalCode
            );
            this.calculateMacroAreaForAddress("addressFor");
            if (this.$refs.addressFrom !== undefined) {
              (this.$refs.addressFrom as Address).forceReload();
            }
          }
        }
      }
    }
    if (
      this.shipment.shipmentType == "EXPORT" ||
      this.shipment.shipmentType == "DOMESTIC"
    ) {
      if (!this.isInboundShipment) {
        this.setAddressAsHome("addressFrom");
      }
    } else if (this.receiverTypeAddress === "fromUser") {
      if (!this.isInboundShipment) {
        this.setAddressAsHome("addressTo");
      }
    }
  }

  closeChangedCourierModal() {
    this.changedCourierModal = false;
  }

  maxSafeValueForCustomer() {
    return CustomerService.getExtraServiceMaxValue(1);
  }

  maxCodForCustomer() {
    return CustomerService.getExtraServiceMaxValue(2);
  }

  maxInsuranceForCustomer() {
    return CustomerService.getExtraServiceMaxValue(3);
  }

  get isUSTariffShipment() {
    return (
      this.shipment.addressTo.countryId == "US" &&
      (this.shipment.addressFrom.macroareaName == "NATIONAL" ||
        this.shipment.addressFrom.macroareaName == "TRANSBORDER") &&
      this.shipment.addressFrom.countryId !== "GB"
    );
  }
  get isWWShip() {
    return (
      this.shipment.addressTo.cee === false ||
      this.shipment.addressFrom.cee === false
    );
  }

  onGelPointSelectedAddress(event: AddressLocatorDto) {
    this.$emit("updateShipmentAccessPoint", event);
    const country = this.countryValues.find(
      (country: any) => country.value === event.countryId
    );
    if (country) {
      this.updateToCountry(country, this.shipment.addressTo.subcountryId);
      this.shipment.addressTo.countryName = country.label;
    }

    this.shipment.addressTo.address = event.address;
    this.shipment.addressTo.secondAddress = event.secondAddress;
    this.shipment.addressTo.thirdAddress = event.thirdAddress;
    this.shipment.addressTo.city = event.city;
    this.shipment.addressTo.countryId = event.countryId;
    this.shipment.addressTo.companyName = event.locatorName;
    this.shipment.addressTo.zipCode = event.zipCode;
    this.shipment.addressTo.province = event.province;
    AddressShipmentDTO.trimStrings(this.shipment.addressTo);
    const storeZipCode = this.$store.getters["customer/storeAddresses"][0]
      .zipCode;
    const storeIsoCode = this.$store.getters["customer/storeAddresses"][0]
      .countryId;
    this.$store.cache
      .dispatch(
        "cachemod/getSubcountries",
        {
          countryId: this.shipment.addressTo.countryId,
          zipcode: this.shipment.addressTo.zipCode,
          storeZipCode: storeZipCode,
          storeIsoCode: storeIsoCode
        },
        { timeout: this.$store.state["cachemod"].timeouts.subCountries }
      )
      .then((res: SubcountryDTO[]) => {
        this.shipment.addressTo.subcountry = res[0].description;
        this.shipment.addressTo.subcountryId = res[0].idSubcountry;
        this.shipment.addressTo.macroareaName = res[0].macroareaName;
      });
  }

  onPackageDimensionChanged() {
    if (
      this.courierChosenByAutopilot === this.shipment.courierId ||
      this.autopilotEnabled
    )
      this.updateAutopilot = true;
    this.isPackageDimensionChange = true;
    this.recalculatePrice();
  }

  get isInboundShipment() {
    return (
      this.$route.query.type === "inbound" &&
      this.$store.getters.features.inbound
    );
  }

  get isThirdPartShipment() {
    return this.$route.query.type === "third_part";
  }

  get courierVisibilityForCurrentCourierServiceAndShipType(): OnlineMbeCourierVisibilityDto | null {
    if (this.$refs.calculator !== undefined) {
      const courier_serviceCalc = (this.$refs.calculator as Calculator)
        .courierService;
      const idCourierService = courier_serviceCalc?.idCourierService
        ? courier_serviceCalc.idCourierService
        : this.shipment.courierServiceId;
      if (idCourierService) {
        const courier_services_visibility_config: OnlineMbeCourierVisibilityDto[] = this
          .$store.getters["customer/courierVisibilityConfig"];
        const filtered_config = courier_services_visibility_config.filter(
          i =>
            i !== null &&
            (i.courierServiceId === idCourierService ||
              i.courierServiceIdBusiness === idCourierService) &&
            i.shipmentType === this.shipment.shipmentType
        );

        if (filtered_config.length === 1) {
          return filtered_config[0];
        }
      }
    }
    return null;
  }

  courierAccountForCurrentCourierServiceAndShipType(): string | null {
    const visibilityConfig = this
      .courierVisibilityForCurrentCourierServiceAndShipType;
    if (visibilityConfig !== null) {
      return visibilityConfig.courierAccount;
    } else {
      return null;
    }
  }

  //This code is meant to retrieve and store in the shipmentDTO the account data that is specific
  //to this courier service and shipment type (if any)
  fillCourierAccountIfNecessary(): Promise<any> {
    const courierAccount = this.courierAccountForCurrentCourierServiceAndShipType();
    if (
      courierAccount !== null &&
      courierAccount !== "" &&
      this.shipment.courierId !== null
    ) {
      //Set the account value in the ShipmentDTO
      this.shipment.accountCongifuration.code = courierAccount;
      //Retrieve the resale value for this account
      return ShipmentService.getAccounts(this.shipment.courierId).then(
        (accounts: CourierServiceCodesConfigurationDto[]) => {
          const account:
            | CourierServiceCodesConfigurationDto
            | undefined = accounts.find(function(element) {
            return (
              element.additionalParameters !== null &&
              element.additionalParameters.filter(
                i => i.value === courierAccount
              ).length > 0
            );
          });
          if (account !== undefined) {
            //Set the resale value in the ShipmentDTO
            this.shipment.accountCongifuration.resale = account.resale;
          }
        }
      );
    } else {
      return Promise.resolve(null);
    }
  }

  courierWeightChange = false;

  @Watch("shipment.customerWeight")
  onShipmentCustomerWeightChange(weight: any, oldWeight: any) {
    if (weight === oldWeight || !this.initResetZonos) return;
    this.resetZonosData("shipment.customerWeight", true);
  }

  @Watch("shipment.courierWeight")
  resetCourier(weight: any, oldWeight: any) {
    if (weight === oldWeight) {
      return;
    }

    this.courierWeightChange = true;
    if (
      (this.$store.state.customer.config.smartChoiceSetting ==
        "CUSTOMER_SMARTCHOICE" ||
        this.$store.state.customer.config.smartChoiceSetting == "BOTH") &&
      this.canSelectCourierServices &&
      this.isDraft > 1
    ) {
      this.shipment.courierId = undefined;
      (this.$refs.calculator as Calculator).courierService = undefined;
    }
  }

  get showTaxDutyLogic() {
    return Boolean(
      this.$store.getters.taxDutyEnabled &&
        this.isTaxDutyEnabled &&
        (!this.hasId ||
          (this.hasId &&
            (this.shipment.landedCosts ||
              String(this.shipment.status).includes("DRAFT")))) &&
        (!this.shipment.addressTo.cee || !this.shipment.addressFrom.cee) &&
        [3, 4].includes(Number(this.shipment.shipPackTypeId))
    );
  }
  get showTaxDutyZonosLogic() {
    return Boolean(
      this.$store.getters.taxDutyEnabled &&
        this.isTaxDutyZonosEnabled &&
        (!this.hasId ||
          (this.hasId &&
            (this.shipment.landedCosts ||
              String(this.shipment.status).includes("DRAFT")))) &&
        (!this.shipment.addressTo.cee || !this.shipment.addressFrom.cee) &&
        [3, 4].includes(Number(this.shipment.shipPackTypeId))
    );
  }

  get isTaxDutyEnabled() {
    return (
      (this.$store.getters["customer/isTaxDutyEnabled"] as boolean) &&
      this.isTaxDutyStoreEnabled
    );
  }
  get isTaxDutyZonosEnabled() {
    return (
      (this.$store.getters["customer/isTaxDutyZonosEnabled"] as boolean) &&
      this.isTaxDutyZonosStoreEnabled
    );
  }

  @Watch("showTaxDutyLogic", { immediate: true })
  async onShowTaxDutyLogicChange(status: boolean) {
    this.$store.commit("shipment/enableTaxDutySection", status);
    if (status) {
      const zonosList = await TaxDutyService.prototype.getZonosCourierServices();
      this.zonosCourierServicesList =
        (zonosList && zonosList.couriersServices) || [];
      this.zonosGuaranteeDisabledCourierServicesList =
        (zonosList && zonosList.guaranteeDisabledCourierServices) || [];
      this.initZonosCourierServiceList = true;
    }
  }
  @Watch("showTaxDutyZonosLogic", { immediate: true })
  async onShowTaxDutyZonosLogicChange(status: boolean) {
    this.$store.commit("shipment/enableTaxDutySection", status);
    if (status) {
      const zonosList = await TaxDutyService.prototype.getZonosCourierServices();
      this.zonosCourierServicesList =
        (zonosList && zonosList.couriersServices) || [];
      this.zonosGuaranteeDisabledCourierServicesList =
        (zonosList && zonosList.guaranteeDisabledCourierServices) || [];
      this.initZonosCourierServiceList = true;
    }
  }

  get reloadZonosCourierServices() {
    return Boolean(
      (this.showTaxDutyLogic || this.showTaxDutyZonosLogic) &&
        !this.isZonosCourierServiceSupported &&
        this.shipment.customerWeight > 0
    );
  }

  @Watch("reloadZonosCourierServices")
  async onReloadZonosCourierServices(status: boolean) {
    const zonosList = await TaxDutyService.prototype.getZonosCourierServices();
    this.zonosCourierServicesList =
      (zonosList && zonosList.couriersServices) || [];
    this.zonosGuaranteeDisabledCourierServicesList =
      (zonosList && zonosList.guaranteeDisabledCourierServices) || [];
  }

  get isGuaranteeDisabledCourierService() {
    if (!this.zonosGuaranteeDisabledCourierServicesList.length) return false;
    if (!this.shipment.courierServiceId) return false;
    return this.zonosGuaranteeDisabledCourierServicesList.includes(
      this.shipment.courierServiceId
    );
  }

  get showProformaAccordion(): boolean {
    if (!this.hasId) {
      return (
        this.shipment.addressTo.cee === false ||
        this.shipment.addressFrom.cee === false ||
        fedexAsksShipmentValue(
          this.shipment.courierId,
          this.shipment.shipmentType
        )
      );
    } else {
      // in edit show always if params have values
      return (
        this.shipment.proforma?.totalValue > 0 ||
        this.shipment.customsDutiesToCustomer ||
        this.shipment.addressTo.cee === false ||
        this.shipment.addressFrom.cee === false ||
        fedexAsksShipmentValue(
          this.shipment.courierId,
          this.shipment.shipmentType
        )
      );
    }
  }

  getCanRequestCustomDuties() {
    if (this.$refs.calculator !== undefined) {
      const courier_serviceCalc = (this.$refs.calculator as Calculator)
        .courierService;
      const idCourierService = courier_serviceCalc?.idCourierService
        ? courier_serviceCalc.idCourierService
        : this.shipment.courierServiceId;
      if (idCourierService) {
        const courier_services_visibility_config: OnlineMbeCourierVisibilityDto[] = this
          .$store.getters["customer/courierVisibilityConfig"];
        const filtered_config = courier_services_visibility_config.filter(
          i =>
            i !== null &&
            (i.courierServiceId === idCourierService ||
              i.courierServiceIdBusiness === idCourierService) &&
            i.shipmentType === this.shipment.shipmentType
        );

        if (filtered_config.length === 1) {
          return filtered_config[0];
        }
      } else if (this.notVisibleCourierService) {
        const courier_services_visibility_config: OnlineMbeCourierVisibilityDto[] = this
          .$store.getters["customer/courierVisibilityConfig"];
        const filtered_config = courier_services_visibility_config.filter(
          i =>
            i !== null &&
            (i.courierServiceId === this.notVisibleCourierService ||
              i.courierServiceIdBusiness === this.notVisibleCourierService) &&
            i.shipmentType === this.shipment.shipmentType
        );

        if (filtered_config.length === 1) {
          return filtered_config[0];
        }
      }
    }
    return null;
  }

  get canRequestCustomDuties(): boolean {
    if (this.$store.state.customer.config.duties === "NONE") {
      this.$emit("changeCanRequestCustomDuties", false);
      return false;
    }
    if (this.$store.state.customer.config.duties === "BY_COURIER_SERVICE") {
      // can change based on courier/ courier service confi
      const canRequest = this.getCanRequestCustomDuties();
      this.$emit(
        "changeCanRequestCustomDuties",
        canRequest?.canRequestCustomDuties
      );
      return canRequest?.canRequestCustomDuties;
    }
    if (this.$store.state.customer.config.duties === "IMPORT_ONLY") {
      this.$emit(
        "changeCanRequestCustomDuties",
        this.shipment.shipmentType === "IMPORT"
      );
      return this.shipment.shipmentType === "IMPORT";
    }
    if (this.$store.state.customer.config.duties === "EXPORT_ONLY") {
      this.$emit(
        "changeCanRequestCustomDuties",
        this.shipment.shipmentType === "EXPORT"
      );
      return this.shipment.shipmentType === "EXPORT";
    }
    if (this.$store.state.customer.config.duties === "IMPORT_EXPORT") {
      this.$emit(
        "changeCanRequestCustomDuties",
        ["EXPORT", "IMPORT"].includes(this.shipment.shipmentType)
      );
      return ["EXPORT", "IMPORT"].includes(this.shipment.shipmentType);
    }
    return false;
  }

  get hasId() {
    return this.shipment?.shipmentId !== "";
  }

  get ddpNotSelected() {
    if (!this.shipment) return false;
    const {
      ddpZonos,
      customsDutiesToCustomer,
      requestedChargeCustomDuties
    } = this.shipment;
    if (!ddpZonos && !customsDutiesToCustomer && !requestedChargeCustomDuties)
      return true;
    return false;
  }

  @Watch("ddpNotSelected")
  onDDPSelectedChange(status: boolean) {
    if (
      !this.shipment ||
      !this.shipment.proforma ||
      !this.shipment.proforma.incoterms
    )
      return;
    this.shipment.proforma.incoterms = status ? "DAP" : "DDP";
  }

  @Watch("shipment.ddpZonos")
  onDDPZonosChange(status: boolean, oldStatus: boolean) {
    if (!status && oldStatus) {
      this.recalculatePrice();
    }
  }

  toggleDutiesToZonos() {
    if (this.showTaxDutyLogic || this.showTaxDutyZonosLogic) {
      this.recalculatePrice();
    }
    if (this.shipment.ddpZonos) {
      this.shipment.customsDutiesToCustomer = false;
      this.shipment.requestedChargeCustomDuties = false;
      this.disableCanChargeCustomDutiesDefinedByMolUser();
    }
    this.resetTaxDutyData();
    this.calculateTaxDutyBtnTriggered = false;
    if (this.isWineShipment) {
      this.recalculatePrice();
    }
  }

  disableCanChargeCustomDutiesDefinedByMolUser() {
    this.shipment.requestedChargeCustomDutiesDefinedByMolUser = false;
    this.shipment.codeAccountForCustomDuties = undefined;
    this.shipment.zipCodeForCustomDuties = undefined;
    this.shipment.countryCodeForCustomDuties = undefined;
  }

  toggleCanChargeCustomDutiesDefinedByMolUser() {
    if (this.showTaxDutyLogic || this.showTaxDutyZonosLogic) {
      this.recalculatePrice();
    }
    if (this.shipment.requestedChargeCustomDutiesDefinedByMolUser) {
      this.shipment.customsDutiesToCustomer = false;
      this.shipment.requestedChargeCustomDuties = false;
      this.shipment.ddpZonos = false;
    } else {
      this.disableCanChargeCustomDutiesDefinedByMolUser();
    }
    this.resetTaxDutyData();
    this.calculateTaxDutyBtnTriggered = false;
  }

  toggleDutiesToCustomer() {
    if (!this.hasId || this.showTaxDutyLogic || this.showTaxDutyZonosLogic) {
      this.recalculatePrice();
    }
    if (this.shipment.customsDutiesToCustomer) {
      this.shipment.requestedChargeCustomDuties = false;
      this.shipment.ddpZonos = false;
      this.disableCanChargeCustomDutiesDefinedByMolUser();
    }

    this.resetTaxDutyData();
    this.calculateTaxDutyBtnTriggered = false;
    if (this.isWineShipment) {
      this.recalculatePrice();
    }
  }

  toggleDutiesThird() {
    if (this.showTaxDutyLogic || this.showTaxDutyZonosLogic) {
      this.recalculatePrice();
    }
    if (this.shipment.requestedChargeCustomDuties) {
      this.shipment.customsDutiesToCustomer = false;
      this.shipment.ddpZonos = false;
      this.disableCanChargeCustomDutiesDefinedByMolUser();
    }

    this.resetTaxDutyData();
    this.calculateTaxDutyBtnTriggered = false;
    if (this.isWineShipment) {
      this.recalculatePrice();
    }
  }

  /**
   * check on status, allow to modify on new or if to be closed or processing
   */
  get disableProformaEdit(): boolean {
    if (this.isInboundShipment) {
      if (
        this.shipment.status === "DRAFT_NO_WAYBILL" ||
        this.shipment.status === "DRAFT_WAYBILL" ||
        this.shipment.status === "CREATED" ||
        this.shipment.delivered === true ||
        (this.isProformaDone && this.hasId)
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return (
        this.hasId &&
        this.shipment?.status !== "DRAFT_TO_BE_CLOSED" &&
        this.shipment?.status !== "DRAFT_NO_WAYBILL" &&
        this.shipment?.status !== "FIRST_DRAFT_TO_BE_CLOSED"
      );
    }
  }

  get autopilotEnabled() {
    return (
      this.$store.getters.features.storeAutopilotEnabled &&
      this.$store.getters["customer/isSmartchoiceSettingAutopilot"] &&
      !this.wineProductUS
    );
  }

  disableCashOnDelivery() {
    if (this.$refs.calculator) {
      if (!this.canSelectCourier) {
        if (this.autopilotEnabled) {
          const noCourierHasCOD = !(this.$refs
            .calculator as Calculator).couriers.some(
            courier => courier.supportsCOD
          );

          return noCourierHasCOD;
        } else {
          return false;
        }
      } else {
        const currentCourierSupportsCOD =
          (this.$refs.calculator as Calculator).couriers.filter(item => {
            return (
              item.idMBEBusiness === this.shipment.courierId && item.supportsCOD
            );
          }).length === 0;

        return this.autopilotEnabled && currentCourierSupportsCOD;
      }
    } else {
      return true;
    }
  }

  get getPickupRequest(): boolean {
    return this.shipment.pickupRequested;
  }

  get totalProformaRequired(): boolean {
    return (
      this.edition &&
      (!this.shipment.addressFrom.cee || !this.shipment.addressTo.cee)
    );
  }

  get isGel() {
    return (
      this.shipment.mbeServiceId ===
        MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
      this.shipment.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
    );
  }

  calculateMacroAreaForAddress(addressFor: string) {
    this.$emit("calculateMacroAreaForAddress", addressFor);
  }

  toggleShipAndPack() {
    this.shipAndPackIncluded = !this.shipAndPackIncluded;
    this.recalculatePrice();
  }

  get canChargeCustomDuties() {
    return (
      !this.isCourierTNT &&
      this.showProformaAccordion &&
      this.shipment.courierId &&
      this.$store.getters["customer/config"].canChargeCustomDuties
    );
  }

  changeProformaTotalValue(e) {
    this.shipment.proforma.totalValue = e;
    this.recalculatePrice();
  }

  setUPSCourier() {
    PriceListService.getCouriers().then(res => {
      if (res) {
        const courierUPS = res.find(item => item.idMBEBusiness === 1);
        if (courierUPS && courierUPS.idCourier) {
          PriceListService.getCourierServices(
            courierUPS.idCourier,
            this.shipment.addressFrom.subcountryId,
            this.shipment.addressTo.subcountryId,
            this.shipment.shipmentType,
            this.shipment.courierShipPackTypeId,
            this.shipment.mbeServiceId
          ).then((res: CourierServiceDTO[]) => {
            if (res.length == 1) {
              const value = res[0];
              this.shipment.courierServiceId = value.idBusiness;
              this.shipment.courierServiceName = value.courierServiceName;
            }
          });
        }
      }
    });
  }

  get isCourierTNT() {
    return this.shipment.courierId === CourierBusiness.TNT;
  }

  get isCourierUPS() {
    return this.shipment.courierId === CourierBusiness.UPS;
  }

  get isCourierDHL() {
    return this.shipment.courierId === CourierBusiness.DHL;
  }

  get isCourierFedex() {
    return this.shipment.courierId === CourierBusiness.FEDEX;
  }

  get wineMissingTotalValue() {
    return (
      this.isWineShipment &&
      this.showProformaAccordion &&
      this.proformaTotalValue === 0
    );
  }

  get isContactRequired() {
    return this.shipment.shipmentType === "EXPORT";
  }

  handleDocumentDeleted(id: any) {
    if (id === this.dualUseIdAdded) {
      this.dualUseIdAdded = null;
    }
    this.shipment.paperlessDocumentIds = this.shipment.paperlessDocumentIds.filter(
      documentId => documentId !== id
    );
  }
}
